<!--suppress TypeScriptValidateTypes -->
<template>
    <div v-if="homePageVisible"><HelloWorld
                msg="ちょい読み"
                :license-text="licenseText"
                :doc-width="documentAreaWidth"
                :license-display="licenseDisplay"
                @affiLink="affiLinkClick"
                @openWork="openWork"
    /></div>
    <div v-else class="book" id="book">
    <p class="no-pointer" style="position: absolute;"></p>
    <span id="userinterfaces" style="position: inherit; top: auto;" v-if="uivis && notResigingDoc" :key="updateUI00">
        <span class="ui-base" style="width: 95vw; background-color: white; padding-top: 1em;">
            <svg-b-pulldown label="買う" width="20vw" height="46" ref="pulldown" itemWidth="280" :fontsize="18"
                        :list-items="buyStores"
                        :list-items-info="storesInfo"
                        :item-width="storesItemWidth"
                        :action="pulldownAction"
                        :abort="pulldownCancel"></svg-b-pulldown>
            <svg-b-pulldown
                listKind="icon" label="サイズ" width="20vw" height="46" ref="iconSelect" itemWidth="160" :fontsize="18"
                :activeItemKey="nowMojisize"
                :list-items="mojiSize"
                :action="iconAction"
                :abort="pulldownCancel"></svg-b-pulldown>
            <svg-b-event @click="svgbClick" :icon-color="iconColor" width="20vw" height="46" sign="popup" ref="svgbutton">
                <path d="M9.5,1 C11.4916319,1 13.6582986,1.60869565 16,2.82608696 L16,22 C13.980437,20.7826087 11.8044599,20.173913 9.47206884,20.173913 C7.682444,20.173913 5.99586859,20.5322746 4.41234262,21.2489978 C3.90919532,21.4767283 3.31670178,21.253459 3.0889712,20.7503117 C3.03033182,20.6207541 3,20.4801793 3,20.337969 L3,3.4429431 C3.00001241,3.05943954 3.21933956,2.70971774 3.56457875,2.54273007 C5.69092685,1.51424336 7.6694006,1 9.5,1 Z M23.5,1 C25.3079569,1 27.2601527,1.50160079 29.3565874,2.50480236 C29.7087407,2.67331737 29.9481823,3.02862733 29.992549,3.43415104 L30,3.57099803 L29.999806,5.33554511 C29.0558834,6.64863375 28.5,8.25940011 28.5,10 C28.5,11.8440791 29.123943,13.5424286 30.1730986,14.8953311 L30,14.663 L29.99994,15.0118923 C28.0960688,16.3186893 26.6052864,18.1836454 25.7635755,20.3707777 C25.0382065,20.2393163 24.2924724,20.173913 23.5279312,20.173913 C21.3327396,20.173913 19.2761016,20.7131037 17.3580172,21.7914849 L17,22 L17,2.82608696 C19.3417014,1.60869565 21.5083681,1 23.5,1 Z" id="Combined-Shape" fill="currentColor"></path>
                <path d="M31.2695755,15.1361402 C30.1676141,13.8490332 29.5,12.1647868 29.5,10.3214286 C29.5,6.27791522 32.7123569,3 36.675,3 C40.6376431,3 43.85,6.27791522 43.85,10.3214286 C43.85,12.2315289 43.1331663,13.970787 41.9590319,15.2743732 C44.9818549,17.1553563 47,20.5514725 47,24.4285714 C47,25.6808408 46.7894602,26.8829324 46.40253,28 L26.59747,28 C26.2105398,26.8829324 26,25.6808408 26,24.4285714 C26,20.4545334 28.1203262,16.9858308 31.2695755,15.1361402 L31.2695755,15.1361402 Z" id="Combined-Shape2" fill="currentColor"></path>
                 <rect id="Rectangle" x="0" y="0" width="60" height="28"></rect>
            </svg-b-event>
            <svg-b-text-button @click="svgbTbClick" sign="popup" width="20vw" height="46" fontweight="Bold" ref="textbutton" :fontsize="22">ⓘ</svg-b-text-button>
        </span>
        <span>
<!--            <br>-->
<!--            <pre class="unselectable no-pointer" style="width: 95vw; background-color: white;"><br>{{ environmentReport }}</pre>-->
        </span>
    </span>
    <span id="footer_u_is" class="uifooter" v-if="((browsevis && !uivis && !slvis) || !inited) && notResigingDoc" :key="updateUI01">
      <svg-b-event @click="goLeft" sign="none" width="45%" height="100%" frame-style="transparent" ref="goLeft" icon-color="#9B9B9B" push-color="rgba(0%,0%,50%,0.2)" :disable-when-mount="leftBDisabled">
          <path v-if="!layoutParams.pageFeedRight || !lastpage" d="M3.57559919,11.7877996 C1.60085029,10.8004251 1.60287589,9.19856206 3.57559919,8.2122004 L16.4244008,1.7877996 C18.3991497,0.800425144 20,1.79246765 20,3.99922997 L20,16.00077 C20,18.2094838 18.3971241,19.1985621 16.4244008,18.2122004 L3.57559919,11.7877996 Z" id="GoLeft" stroke="#FFFFFF" stroke-width="2" fill="currentColor"></path>
          <path v-else d="M0,3.99620271 C0,1.78916089 1.78883037,0 3.99620271,0 L12.0037973,0 C14.2108391,0 16,1.78883037 16,3.99620271 L16,12.0037973 C16,14.2108391 14.2111696,16 12.0037973,16 L3.99620271,16 C1.78916089,16 0,14.2111696 0,12.0037973 L0,3.99620271 Z" id="GoLeft" stroke="#FFFFFF" stroke-width="2" fill="currentColor"></path>
      </svg-b-event>
      <svg-b-event @click="jumpUIDisplay" sign="none" width="10%" height="100%" frame-style="transparent" ref="jumpUIDisplay" icon-color="#9B9B9B" :disable-when-mount="jumpUIDisabled">
        <g id="Jump" stroke="#FFFFFF" stroke-width="2" fill="currentColor">
            <rect id="Rectangle" x="0" y="4" width="53" height="6" rx="2"></rect>
            <circle id="Oval" cx="34" cy="7" r="7"></circle>
        </g>
      </svg-b-event>
      <svg-b-event @click="goRight" sign="none" width="45%" height="100%" frame-style="transparent" ref="goRight" icon-color="#9B9B9B" :disable-when-mount="rightBDisabled">
          <path v-if="layoutParams.pageFeedRight || !lastpage" d="M16.4244008,10.7877996 C18.3991497,9.80042514 18.3971241,8.19856206 16.4244008,7.2122004 L3.57559919,0.787799597 C1.60085029,-0.199574856 0,0.792467646 0,2.99922997 L0,15.00077 C0,17.2094838 1.60287589,18.1985621 3.57559919,17.2122004 L16.4244008,10.7877996 Z" id="GoRight" stroke="#FFFFFF" stroke-width="2" fill="currentColor"></path>
          <path v-else d="M0,3.99620271 C0,1.78916089 1.78883037,0 3.99620271,0 L12.0037973,0 C14.2108391,0 16,1.78883037 16,3.99620271 L16,12.0037973 C16,14.2108391 14.2111696,16 12.0037973,16 L3.99620271,16 C1.78916089,16 0,14.2111696 0,12.0037973 L0,3.99620271 Z" id="GoLeft" stroke="#FFFFFF" stroke-width="2" fill="currentColor"></path>
      </svg-b-event>
    </span>
    <span id="footer_u_i_slider" class="sliderbox use-pointer" v-if="!uivis && slvis">
      <input type="range" id="pageSlider" :min="0" :max="layoutParams.numOfPages - 1" v-model="pageSliderValue" :style="{ width:'75%'}" @change="pageSliderChange">
      <div class="slidervalue">{{pageNumber}}</div>
    </span>
    <span class="background" :style="{ left:'0px',top:'0px',width:'100vw',height: topFiller + 'px' }" id="bg-top"></span>
    <span class="background" :style="{ left:'0px',bottom:'0px',width:'100vw',height: bottomFiller + 'px' }" id="bg-bottom"></span>
    <bookpage-view
      @click="pageviewClick"
      @showLastpage="showLastpage"
      @advance="pvAdvance"
      @pagesUpdate="pagesUpdate"
      :uivis="uivis"
      :browsevis="browsevis"
      :nowIndex="displayIndex"
      :loading="paging"
      :loading-message="loadingMessage"
      ref="bookpage"
    ></bookpage-view>
      <license-view
              v-if="aboutShow"
              @hide="aboutShow = false"
              taglabel="作品について"
              :ppwidth="documentAreaWidth * 0.9"
              :ppheight="documentAreaHeight * 0.9"
              ref="about"
              :messages="aboutText"
      ></license-view>
      <license-view
              v-if="licenseShow"
              @hide="licenseShow = false"
              taglabel="各種情報"
              :ppwidth="documentAreaWidth * 0.9"
              :ppheight="documentAreaHeight * 0.9"
              ref="licenses"
              :messages="licenseText"
      ></license-view>
      <lastpage-sheet
        v-if="lastpageShow"
        @hide="lastpageShow = false"
        :list-items="buyStores"
        :list-items-info="storesInfo"
        :item-width="storesItemWidth"
        :buyaction="lastpageBuyAction"
        :ppwidth="documentAreaWidth * 0.9"
        :ppheight="documentAreaHeight * 0.8"
        ref="lastpage"
        :title="layoutParams.contentsTitle"
        :author="layoutParams.authorName"
        taglabel="お読みいただきありがとうございます"
        title-color="#eeeeee"
        edge-color="#262626"
        :message="lastMessage"
        :onegai="onegai"
      ></lastpage-sheet>
      <div v-if="helpSheetShow" ref="help" id="help" style="position: fixed; left: 0; top: 0; width: 100vw; height: 100vh;"></div>
      <auth-compo v-if="authDisp" :author-i-d="authorId" :work-i-d="contentsId" :email="nowEmail" @result="authResult"></auth-compo>
  </div>
</template>

<script>
import Heading from "@/components/Heading.vue"
import Mouseover from "@/components/Mouseover"
import SVGBMouseEvent from "@/components/SVGBMouseEventSlot"
import SVGBTextButton from "@/components/SVGBTextButtonSlot"
import SVGBPulldown from "@/components/SVGBPulldownSlot"
import BookpageView from "@/components/BookpageView"
import LicenseView from "@/components/LicenseView"
import LastpageSheet from "@/components/LastpageSheet"
import AuthCompo from "@/components/auth"
import HelloWorld from "@/components/HelloWorld"
import DialogHelper from '@/DialogHelper'
import {mapState} from 'vuex'
import WebFontLoader from 'webfontloader'
import Dialog from "@/components/Dialog"
// import composed from "@/assets/testdata/composed"
const zlib = require('zlib')
let timer = 0;
let debugOut = false

const amsAsoID = "choiyomi-22"
//  //以下、リーダーとの共通定数
const dotSample = "﹅﹆●○△◎◉•◦"
const matsukin = "([｛〔〈《「『【〘〖〝‘“｟«"
const toukin_bura = "。．、，"
const toukin_wa_h = "｝〕〉》」』】〙〗〟’”｠"
const toukin_wa = "ゝゞーァィゥェォッャュョヮヵヶぁぃぅぇぉっゃゅょゎゕゖㇰㇱㇲㇳㇴㇵㇶㇷㇸㇹㇷ゚ㇺㇻㇼㇽㇾㇿ々〻"
const han_toukin = ",)]»"
const toukin_hyphen = "‐゠–〜～"
const toukin_kugiri = "？！?!‼⁇⁈⁉"
const toukin_nakaguro = "・:;/"
// const tateMoji = "‥… ⋯＝｛｝［］（）｟｠―、。〈〉《》「」『』【】〔〕〘〙〚〛〝〞〟ぁぃぅぇぉっゃゅょゎゕゖ゛゜゠ァィゥェォッャュョヮヵヶーㄧㇰㇱㇲㇳㇴㇵㇶㇷㇸㇹㇺㇻㇼㇽㇾㇿ㌀㌁㌂㌃㌄㌅㌆㌇㌈㌉㌊㌋㌌㌍㌎㌏㌐㌑㌒㌓㌔㌕㌖㌗㌘㌙㌚㌛㌜㌝㌞㌟㌠㌡㌢㌣㌤㌥㌦㌧㌨㌩㌪㌫㌬㌭㌮㌯㌰㌱㌲㌳㌴㌵㌶㌷㌸㌹㌺㌻㌼㌽㌾㌿㍀㍁㍂㍃㍄㍅㍆㍇㍈㍉㍊㍋㍌㍍㍎㍏㍐㍑㍒㍓㍔㍕㍖㍗㍻㍼㍽㍾㍿，．［］＿｛｜｝～｟｠￣🈀"
const tateRoll = "←↑→↓⇄⇅⇆⇦⇧⇨⇩☜☝☞☟➡⬅⬆⬇°ʻ′″∥ ‘’“”❛❜❝❞‹›«»<>⟨⟩⟪⟫❨❩()❮❯{}❴❵[]⟦⟧［］❪❫＜＞⸨⸩❲❳⦗⦘❬❭❰❱–—─﹐﹑﹒﹙﹚﹛﹜﹝﹞"
const numeral = ['万','億','兆','京','垓','𥝱','穣','溝','澗','正','載','極','恒河沙','阿僧祇','那由他','不可思議','無量大数']
const gaijiArea = [0xE000,0xF8FF ,0xF0000,0xFFFFD ,0x100000,0x10FFFD]
const tentativeSize = 10
const fontMeasureRatio = 5
const rubyRatio = 0.5
const rubySize = Math.floor(tentativeSize * rubyRatio * 10) / 10
const charSpacing = 1.2
const lineSpacing = 2.1                 //改行幅（文字高を1とする。文字高 + 次行間隔）
const hantWidthRatio = 0.5
const subjectRatio = 1.2
const drawTextBaseline = 'bottom' //'ideographic'
const calcFont = '"Noto Serif JP"'
const vertFont = 'Noto-Serif-JPVO'
const picCapFont = '"Noto Suns JP"'
const tentaFontStyle = `${tentativeSize * fontMeasureRatio}px ${calcFont}`
const rubyFontStyle = `${rubySize * fontMeasureRatio}px ${calcFont}`
// 一部のタグではタグの入れ子を受け入れる。ただし、パラメーター1の位置のみ。下記コメントの「param1:*テキスト」のみ
const TagCmds = {
  Unknown: -1,                    // param1:（無し）
  Newpage:0, Np:0,                // param1:（無し。段落中のどこにあっても段落末で発効）
  Picture:1, Pic:1, P:1,          // param1:画像番号（0スタート。省略可。省略時は自動インクリメント。初回自動インクリメントの時は0から。タグ位置移行の次ページで画像を表示する。ただしページに当タグのみ（つまり当タグとNewpageタグのみの行）の場合は該当ページに表示する）
  Dot:2, D:2,                     // param1:圏点文字（省略時は「・」）／'End'
  Line:3, L:3,                    // param1:線指定値（LineStyle。省略時は「single」）／'End'
  Indent:4, I:4,                  // param1:整数値（段落中で指定した場合もその段落の先頭で発効し、次段以降にも引き継がれる。デフォルトは0）
  Subject:5, Sub:5,               // param1:（無し。段落中のどこにあっても段落全体に発効。段落全体を本文より少し大きめの文字で余裕を持って描画する）
  Ruby:6, R:6,                    // param1:対象テキスト param2:ルビ
  Strikethrough:7, Strike:7, St:7, S:7, // param1:線指定値（LineStyle。省略時は「single」）／'End'
  Vertalignsuper:8, Vasp:8, Super:8, Sp:8,  // param1:対象テキスト（対象テキストを上付き文字として描画する）
  Vertalignsub:9, Vasb:9, Subscript:9, Sb:9, // param2:対象テキスト（対象テキストを下付き文字として描画する）
  TextCombineUpright:32768, Textcombineupright:32768, Tcu:32768,  // param1:モード param2:オプション（縦組み表示時の縦中横処理を指定する。段落を超えて適用。未指定時点ではnormalモード）
  Feed:14, Fd:14,                 // param1:（無し。段落中のどこにあっても先頭で発効）
  Nombre:32, Nb:32,               // param1:モード（段落中で指定した場合もその段落の先頭で発効し、次段以降にも引き継がれる。その段落の先頭を含むページ以降のノンブルの表示モードを指定する。省略時は「on」）
  Fillpicture:33, Fillpic:33, Fpic:33, Fp:33, // param1:画像番号（0スタート。省略可。省略時は自動インクリメント。初回自動インクリメントの時は0から。タグ位置移行の次ページで画像を表示する。ただしページに当タグのみ（つまり当タグとNewpageタグのみの行）の場合は該当ページに表示する）
}
const NombreMode = {
  on:0,
  off:1,
}
const LineStyle = {
  end:-1,
  single:0,
  double:1,
  thick:2,
  wavy:3,
  dotted:4,
}
const TCURole = {
  hasParam:16,
  numParam:16,
  tcukParam:48,
  oneFull:64,
}
const TCUNumParamFlag = {
  oneFull:      0x8000,
  //
  numParamMask: 0x00FF,
}
const TCUMode = {
  none:0,                       //縦中横を考慮しない。半角英数カナは全て90°時計回りさせて描画（digit-op:0と同じ）
  normal:1,                     //縦中横を通常設定（digit-op:nullと同じ）で行う（ドキュメントデフォルト＝TCUタグ未指定時値）
  digit:1 | TCURole.numParam,   //半角英数カナブロックがオプションで指定した文字数（0〜4）以下の場合に縦中横。越えたら90°時計回りで文字列描画（オプション省略時は3とみなす）
  digitone:1 | TCURole.numParam | TCURole.oneFull,  //半角英数カナブロックが1文字だった場合、全角に変換して描画。それ以外はdigitと同じ
  digitnum:2 | TCURole.numParam,//半角数字ブロックがオプションで指定した文字数（0〜4）以下の場合に縦中横。越えたら90°時計回りで文字列描画（オプション省略時は3とみなす）
  digitnumone:2 | TCURole.numParam | TCURole.oneFull, //半角数字ブロックが1文字だった場合、全角に変換して描画。それ以外はdigitnumと同じ
  full:3 | TCURole.numParam,    //半角英数カナブロックがオプションで指定した文字数（0〜4）以下（0、1以外の指定時は2文字を下限）の場合に縦中横。それ以外は半角英数カナを全角に変換する（オプション省略時は3とみなす）
  fullnum:4 | TCURole.numParam, //半角数字ブロックがオプションで指定した文字数（0〜4）以下（0、1以外の指定時は2文字を下限）の場合に縦中横。それ以外は半角数字を全角に変換する（オプション省略時は3とみなす）
  kanji:5 | TCURole.tcukParam,  //半角数字を漢数字に、英字カナは全角に変換する。表現オプション（TCUKOption）の指定が可能
  keta:6 | TCURole.tcukParam,   //半角数字を整数値と見なし、命数法に従って漢数字で表記する（塵劫記-万進による）。英字カナは全角に変換する。表現オプション（TCUKOption）の指定が可能
  comeback:32768, cb:32768,     //直前までのモードを取り消し、その前のモードに設定する
}
const TCUKOption = {
  none:0,       //正負の記号（+、-）があった場合、正は省略、負は全角の−で表現する
  sign:1,       //正負の記号（+、-）があった場合、全角の＋、−で表現する
  bun:2,        //正負の記号（+、-）があった場合、「正の」、「負の」と表現する
  kana:3,       //正負の記号（+、-）があった場合、「プラス」、「マイナス」と表現する
  symbol:4,     //正負の記号（+、-）があった場合、正はスペース、負は▲で表現する
  symbol2:5,    //正負の記号（+、-）があった場合、正はスペース、負は△で表現する
}
const WordType = {
  unknown:      0x00000000,
  space:        0x00000001,     //半角スペース
  ascii:        0x00000002,     //半角英数字記号
  hankana:      0x00000004,     //半角カナ記号
  kaomoji:      0x00000008,     //顔文字
  hojokigou:    0x00000010,     //全角幅と異なる文字
  linedash:     0x00000100,     //2連続ダッシュ
  ellipsis:     0x00000200,     //2連続リーダー
  gaiji:        0x00000800,     //外字（ユニコード私用領域）
  others:       0x00000080,     //その他（全角文字含む）
  //
  numberOnly:   0x00001000,     //数値表現として解釈できる半角数字記号のみで構成されている場合
  //
  others_htsume:0x01000000,     //全角記号で半分の幅に収まる字
  //
  // others_tate:  0x00010000,  //全角文字で縦書きグリフが存在する字
  tc_ur:        0x00020000,     //縦書き時縦中横で描画（文字幅は文字サイズ）
  to_ur:        0x00030000,     //縦書き時に全角に変換し正立描画（文字幅は文字サイズ）
  to_sw:        0x00040000,     //縦書き時に90°時計回りに回転して描画（文字幅はプロポーショナル）
  //
  tagControl:   0x00100000,     //タグ専用に1文字分確保。非表示
  //
  ruby_continue:0x10000000,
  ruby_slim:    0x20000000,
  ruby_off:     0x40000000,
}
const PictureFlags = {
  numberMask:           0x00FFFFFF,
  coverPage:            0x80000000,
  fillPage:             0x01000000,
}
const tagControlCharCode = 1
const tagControlStr = String.fromCharCode(tagControlCharCode)
const WordTypeMask = {
  othersMask:           WordType.others,
  hantsumeMask:         WordType.others_htsume,
  // tatemojiMask:         WordType.others_tate,
  noGapMask:            WordType.space | WordType.ascii | WordType.hankana | WordType.kaomoji,
  wordSaveMask:         WordType.ascii | WordType.kaomoji | WordType.hankana,
  tcuAreaMask:          WordType.ascii | WordType.hankana,
  sentenceStructMask:   WordType.space | WordType.ascii | WordType.hankana | WordType.hojokigou,
  sentenceMask:         WordType.ascii | WordType.hankana | WordType.hojokigou,
  numberMask:           WordType.numberOnly,
  linedashMask:         WordType.linedash,
  ellipsisMask:         WordType.ellipsis,
  //
  tateHanMask:          WordType.tc_ur | WordType.to_ur | WordType.to_sw,
  //
  tagControlMask:       WordType.tagControl,
  //

  ruby_continueMask:    WordType.ruby_continue,
  ruby_slimMask:        WordType.ruby_slim,
  ruby_offMask:         WordType.ruby_off,
}
// const VerticalOpe = {
//   none:0,               //横書き文書時
//   normal:1,             //正立。そのまま描画
//   vertical:2,           //正立。そのまま（縦書きグリフで）描画
//   mixed:3,              //該当文字列を時計回りに90°回転して描画
//   zenUpright:4,         //1文字ずつ全角に変換して正立描画
//   combineUpright:5,     //該当文字列を縦中横描画
// }
const PropFlag = {
  none:             0x0000,
  subject:          0x0001,
  newpage:          0x0002,
  hasLine:          0x0004,
  hasDot:           0x0008,
  hasRuby:          0x0010,
  hasLine2:         0x0020,
  hasRuby2:         0x0040,
  hasStrike:        0x0080,
  feed:             0x0100,
  //    以下はレイアウト時にワーキングフラグとして使用する
  hasPicture:   0x01000000,
  isWpage:      0x02000000
}
//  //
const crypto = require('crypto')
const publicKey = `-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAxBHSaAUqvUajTl+KIjbL
t1wlrvgSVhdDHxPR+q+CdUX2mgBZ4A/y48YfGRqztpbHkwQwe/ZtuFE67czFXpse
MNRwjTiO8+T29U14XTiBRCOd3y/PafmSaa41NKn2gEobwhXHSD0BCgHnEMfIWNvM
8/mqIsUtzY8kez7fbB2TMbQNdSJUTJdHhy8dfbjagbcXyZlzCs2kNNgNkjs/e+kc
VHUI1e/v8tgeanAUb2JsMP5fmEO7R4GYp1WjqfalnRTm1+ju/a9yoHPPSuKezL02
aYuatAj6NZhiWAnbR15KiyhufebvYkyNJlQpXYOWd7a6VOpVyeRVek5d7HvCD06B
lQIDAQAB
-----END PUBLIC KEY-----
`
const taggedFile = 'tagged.json'
const infoFile = 'workinfo.json'
const gaijiListFile = 'gaijisvg.json'

const SpecialLineIndex = {
  lineFeed:                 -1,
  lineFeedWp:               -2.
}

export default {
  components: {
    LastpageSheet,
    SvgBEvent: SVGBMouseEvent,
    SvgBTextButton: SVGBTextButton,
    SvgBPulldown: SVGBPulldown,
    BookpageView: BookpageView,
    LicenseView,
    Mouseover,
    Heading,
    AuthCompo,
    HelloWorld,
  },
  data() {
    return {
      queryData: {
        type: Object,
        default: null
      },
      authorId: {
        type: Number,
        default: NaN
      },
      contentsId: {
        type: Number,
        default: NaN
      },
      displayIndex: {
        type: Number,
        default: NaN
      },
      nowEmail: {
        type: String,
        default: null,
      },
      authDisp: false,

      lastMessage: null,
      buyStores: null,
      storesInfo: {},
      storesItemWidth: 320,
      mojiSize: {
        Biggest: { value: 8, gRatio: 0.6, icon:"data:image/svg+xml;charset=utf-8;base64," + btoa(`<?xml version="1.0" encoding="UTF-8"?>
<svg width="40px" height="40px" viewBox="0 0 40 40" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <!-- Generator: Sketch 43.2 (39069) - http://www.bohemiancoding.com/sketch -->
    <title>msize_biggest</title>
    <desc>Created with Sketch.</desc>
    <defs></defs>
    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="msize_biggest">
            <rect id="Rectangle-3" fill="#EFEFEF" x="0" y="0" width="40" height="40" rx="12"></rect>
            <path d="M20.5,11.96875 L18.8125,19.6875 L22.1875,19.6875 L20.5,11.96875 Z M16,7.03125 C16.4375022,7.07291687 16.8958309,7.09375 17.375,7.09375 C17.6666681,7.09375 18.1145803,7.08333344 18.71875,7.0625 L20.59375,7.03125 C21.0312522,7.03125 21.4374981,7.17708188 21.8125,7.46875 C22.2916691,7.84375188 22.6145825,8.40624625 22.78125,9.15625 L26.5,26.21875 C26.6041672,26.7395859 26.7291659,27.0729159 26.875,27.21875 C27.0208341,27.3645841 27.2499984,27.4062503 27.5625,27.34375 C27.8333347,27.3020831 28.0416659,27.4270819 28.1875,27.71875 C28.3333341,27.9687513 28.40625,28.2916647 28.40625,28.6875 C28.40625,29.0625019 28.3333341,29.3854153 28.1875,29.65625 C28.0416659,29.9270847 27.8333347,30.0520834 27.5625,30.03125 C26.8124962,29.9270828 25.9583381,29.875 25,29.875 C24.0624953,29.875 23.2083372,29.9270828 22.4375,30.03125 C22.104165,30.0520834 21.8437509,29.9270847 21.65625,29.65625 C21.4895825,29.3854153 21.40625,29.0625019 21.40625,28.6875 C21.40625,28.2916647 21.4895825,27.9687513 21.65625,27.71875 C21.8437509,27.4270819 22.104165,27.3020831 22.4375,27.34375 C22.770835,27.4062503 23.0624987,27.3541675 23.3125,27.1875 C23.6041681,26.9791656 23.6979172,26.6562522 23.59375,26.21875 L22.78125,22.375 L18.21875,22.375 L17.40625,26.21875 C17.2812494,26.7187525 17.2604162,27.0416659 17.34375,27.1875 C17.4479172,27.3333341 17.6874981,27.3854169 18.0625,27.34375 C18.3541681,27.3020831 18.5937491,27.4270819 18.78125,27.71875 C18.9270841,27.9687513 19,28.2916647 19,28.6875 C19,29.0625019 18.9270841,29.3854153 18.78125,29.65625 C18.5937491,29.9270847 18.3541681,30.0520834 18.0625,30.03125 C17.3749966,29.9479162 16.6145875,29.90625 15.78125,29.90625 C14.9479125,29.90625 14.1250041,29.9479162 13.3125,30.03125 C13.0833322,30.0520834 12.9062506,29.9270847 12.78125,29.65625 C12.6562494,29.3854153 12.59375,29.0625019 12.59375,28.6875 C12.59375,28.2916647 12.6562494,27.9687513 12.78125,27.71875 C12.9062506,27.4270819 13.0833322,27.3020831 13.3125,27.34375 C13.6875019,27.3854169 13.9479159,27.3437506 14.09375,27.21875 C14.2395841,27.0729159 14.3749994,26.7395859 14.5,26.21875 L17.84375,10.84375 C17.9687506,10.2395803 18.0000003,9.88541719 17.9375,9.78125 C17.8749997,9.69791625 17.6145856,9.66666656 17.15625,9.6875 L16,9.71875 C15.7083319,9.73958344 15.4791675,9.61458469 15.3125,9.34375 C15.1458325,9.07291531 15.0625,8.75000187 15.0625,8.375 C15.0625,7.97916469 15.1458325,7.65625125 15.3125,7.40625 C15.4791675,7.11458187 15.7083319,6.98958313 16,7.03125 Z" id="A" fill="#000000"></path>
        </g>
    </g>
</svg>`), exp: "最大" },
        Bigger: { value: 5, gRatio: 0.7, icon:"data:image/svg+xml;charset=utf-8;base64," + btoa(`<?xml version="1.0" encoding="UTF-8"?>
<svg width="40px" height="40px" viewBox="0 0 40 40" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <!-- Generator: Sketch 43.2 (39069) - http://www.bohemiancoding.com/sketch -->
    <title>msize_bigger</title>
    <desc>Created with Sketch.</desc>
    <defs></defs>
    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="msize_bigger">
            <rect id="Rectangle-3" fill="#EFEFEF" x="0" y="0" width="40" height="40" rx="12"></rect>
            <path d="M20,13.2226562 L18.5234375,19.9765625 L21.4765625,19.9765625 L20,13.2226562 Z M16.0625,8.90234375 C16.4453144,8.93880227 16.8463521,8.95703125 17.265625,8.95703125 C17.5208346,8.95703125 17.9127578,8.94791676 18.4414062,8.9296875 L20.0820312,8.90234375 C20.4648457,8.90234375 20.8203109,9.02994664 21.1484375,9.28515625 C21.5677104,9.61328289 21.8502597,10.1054655 21.9960938,10.7617188 L25.25,25.6914062 C25.3411463,26.1471377 25.4505202,26.4388014 25.578125,26.5664062 C25.7057298,26.6940111 25.9062486,26.730469 26.1796875,26.6757812 C26.4166679,26.6393227 26.5989577,26.7486966 26.7265625,27.0039062 C26.8541673,27.2226573 26.9179688,27.5052066 26.9179688,27.8515625 C26.9179688,28.1796891 26.8541673,28.4622384 26.7265625,28.6992188 C26.5989577,28.9361991 26.4166679,29.045573 26.1796875,29.0273438 C25.5234342,28.9361975 24.7760459,28.890625 23.9375,28.890625 C23.1171834,28.890625 22.369795,28.9361975 21.6953125,29.0273438 C21.4036444,29.045573 21.1757821,28.9361991 21.0117188,28.6992188 C20.8658847,28.4622384 20.7929688,28.1796891 20.7929688,27.8515625 C20.7929688,27.5052066 20.8658847,27.2226573 21.0117188,27.0039062 C21.1757821,26.7486966 21.4036444,26.6393227 21.6953125,26.6757812 C21.9869806,26.730469 22.2421864,26.6848966 22.4609375,26.5390625 C22.7161471,26.3567699 22.7981775,26.0742207 22.7070312,25.6914062 L21.9960938,22.328125 L18.0039062,22.328125 L17.2929688,25.6914062 C17.1835932,26.1289084 17.1653642,26.4114577 17.2382812,26.5390625 C17.3294275,26.6666673 17.5390609,26.7122398 17.8671875,26.6757812 C18.1223971,26.6393227 18.3320304,26.7486966 18.4960938,27.0039062 C18.6236986,27.2226573 18.6875,27.5052066 18.6875,27.8515625 C18.6875,28.1796891 18.6236986,28.4622384 18.4960938,28.6992188 C18.3320304,28.9361991 18.1223971,29.045573 17.8671875,29.0273438 C17.265622,28.9544267 16.6002641,28.9179688 15.8710938,28.9179688 C15.1419234,28.9179688 14.4218786,28.9544267 13.7109375,29.0273438 C13.5104157,29.045573 13.3554693,28.9361991 13.2460938,28.6992188 C13.1367182,28.4622384 13.0820312,28.1796891 13.0820312,27.8515625 C13.0820312,27.5052066 13.1367182,27.2226573 13.2460938,27.0039062 C13.3554693,26.7486966 13.5104157,26.6393227 13.7109375,26.6757812 C14.0390641,26.7122398 14.2669264,26.6757818 14.3945312,26.5664062 C14.5221361,26.4388014 14.6406245,26.1471377 14.75,25.6914062 L17.6757812,12.2382812 C17.7851568,11.7096328 17.8125003,11.39974 17.7578125,11.3085938 C17.7031247,11.2356767 17.4752624,11.2083332 17.0742188,11.2265625 L16.0625,11.2539062 C15.8072904,11.2721355 15.6067716,11.1627616 15.4609375,10.9257812 C15.3151034,10.6888009 15.2421875,10.4062516 15.2421875,10.078125 C15.2421875,9.7317691 15.3151034,9.44921984 15.4609375,9.23046875 C15.6067716,8.97525914 15.8072904,8.86588523 16.0625,8.90234375 Z" id="A" fill="#000000"></path>
        </g>
    </g>
</svg>`), exp: "大" },
        Big: { value: 2, gRatio: 0.8, icon:"data:image/svg+xml;charset=utf-8;base64," + btoa(`<?xml version="1.0" encoding="UTF-8"?>
<svg width="40px" height="40px" viewBox="0 0 40 40" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <!-- Generator: Sketch 43.2 (39069) - http://www.bohemiancoding.com/sketch -->
    <title>msize_big</title>
    <desc>Created with Sketch.</desc>
    <defs></defs>
    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="msize_big">
            <rect id="Rectangle-3" fill="#EFEFEF" x="0" y="0" width="40" height="40" rx="12"></rect>
            <path d="M20.5,13.4765625 L19.234375,19.265625 L21.765625,19.265625 L20.5,13.4765625 Z M17.125,9.7734375 C17.4531266,9.80468766 17.7968732,9.8203125 18.15625,9.8203125 C18.3750011,9.8203125 18.7109352,9.81250008 19.1640625,9.796875 L20.5703125,9.7734375 C20.8984391,9.7734375 21.2031236,9.88281141 21.484375,10.1015625 C21.8437518,10.3828139 22.0859369,10.8046847 22.2109375,11.3671875 L25,24.1640625 C25.0781254,24.5546895 25.1718745,24.804687 25.28125,24.9140625 C25.3906255,25.023438 25.5624988,25.0546877 25.796875,25.0078125 C26.000001,24.9765623 26.1562495,25.0703114 26.265625,25.2890625 C26.3750005,25.4765634 26.4296875,25.7187485 26.4296875,26.015625 C26.4296875,26.2968764 26.3750005,26.5390615 26.265625,26.7421875 C26.1562495,26.9453135 26.000001,27.0390626 25.796875,27.0234375 C25.2343722,26.9453121 24.5937536,26.90625 23.875,26.90625 C23.1718715,26.90625 22.5312529,26.9453121 21.953125,27.0234375 C21.7031237,27.0390626 21.5078132,26.9453135 21.3671875,26.7421875 C21.2421869,26.5390615 21.1796875,26.2968764 21.1796875,26.015625 C21.1796875,25.7187485 21.2421869,25.4765634 21.3671875,25.2890625 C21.5078132,25.0703114 21.7031237,24.9765623 21.953125,25.0078125 C22.2031263,25.0546877 22.4218741,25.0156256 22.609375,24.890625 C22.8281261,24.7343742 22.8984379,24.4921891 22.8203125,24.1640625 L22.2109375,21.28125 L18.7890625,21.28125 L18.1796875,24.1640625 C18.085937,24.5390644 18.0703122,24.7812495 18.1328125,24.890625 C18.2109379,25.0000005 18.3906236,25.0390627 18.671875,25.0078125 C18.8906261,24.9765623 19.0703118,25.0703114 19.2109375,25.2890625 C19.320313,25.4765634 19.375,25.7187485 19.375,26.015625 C19.375,26.2968764 19.320313,26.5390615 19.2109375,26.7421875 C19.0703118,26.9453135 18.8906261,27.0390626 18.671875,27.0234375 C18.1562474,26.9609372 17.5859406,26.9296875 16.9609375,26.9296875 C16.3359344,26.9296875 15.718753,26.9609372 15.109375,27.0234375 C14.9374991,27.0390626 14.804688,26.9453135 14.7109375,26.7421875 C14.617187,26.5390615 14.5703125,26.2968764 14.5703125,26.015625 C14.5703125,25.7187485 14.617187,25.4765634 14.7109375,25.2890625 C14.804688,25.0703114 14.9374991,24.9765623 15.109375,25.0078125 C15.3906264,25.0390627 15.585937,25.007813 15.6953125,24.9140625 C15.804688,24.804687 15.9062495,24.5546895 16,24.1640625 L18.5078125,12.6328125 C18.601563,12.1796852 18.6250002,11.9140629 18.578125,11.8359375 C18.5312498,11.7734372 18.3359392,11.7499999 17.9921875,11.765625 L17.125,11.7890625 C16.9062489,11.8046876 16.7343756,11.7109385 16.609375,11.5078125 C16.4843744,11.3046865 16.421875,11.0625014 16.421875,10.78125 C16.421875,10.4843735 16.4843744,10.2421884 16.609375,10.0546875 C16.7343756,9.83593641 16.9062489,9.74218734 17.125,9.7734375 Z" id="A" fill="#000000"></path>
        </g>
    </g>
</svg>`), exp: "やや大" },
        Normal: { value: 0, gRatio: 1, icon:"data:image/svg+xml;charset=utf-8;base64," + btoa(`<?xml version="1.0" encoding="UTF-8"?>
<svg width="40px" height="40px" viewBox="0 0 40 40" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <!-- Generator: Sketch 43.2 (39069) - http://www.bohemiancoding.com/sketch -->
    <title>msize_normal</title>
    <desc>Created with Sketch.</desc>
    <defs></defs>
    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="msize_normal">
            <rect id="Rectangle-3" fill="#EFEFEF" x="0" y="0" width="40" height="40" rx="12"></rect>
            <path d="M20,14.6035156 L18.8398438,19.9101562 L21.1601562,19.9101562 L20,14.6035156 Z M16.90625,11.2089844 C17.2070328,11.2376304 17.5221338,11.2519531 17.8515625,11.2519531 C18.0520843,11.2519531 18.360024,11.2447917 18.7753906,11.2304688 L20.0644531,11.2089844 C20.3652359,11.2089844 20.64453,11.3092438 20.9023438,11.5097656 C21.2317725,11.7675794 21.4537755,12.1542943 21.5683594,12.6699219 L24.125,24.4003906 C24.1966149,24.7584653 24.2825516,24.9876297 24.3828125,25.0878906 C24.4830734,25.1881515 24.6406239,25.2167971 24.8554688,25.1738281 C25.0416676,25.1451821 25.1848953,25.2311188 25.2851562,25.4316406 C25.3854172,25.6035165 25.4355469,25.8255195 25.4355469,26.0976562 C25.4355469,26.35547 25.3854172,26.577473 25.2851562,26.7636719 C25.1848953,26.9498707 25.0416676,27.0358074 24.8554688,27.0214844 C24.3398412,26.9498694 23.7526075,26.9140625 23.09375,26.9140625 C22.4492155,26.9140625 21.8619818,26.9498694 21.3320312,27.0214844 C21.1028634,27.0358074 20.9238288,26.9498707 20.7949219,26.7636719 C20.680338,26.577473 20.6230469,26.35547 20.6230469,26.0976562 C20.6230469,25.8255195 20.680338,25.6035165 20.7949219,25.4316406 C20.9238288,25.2311188 21.1028634,25.1451821 21.3320312,25.1738281 C21.5611991,25.2167971 21.7617179,25.1809902 21.9335938,25.0664062 C22.1341156,24.9231764 22.1985681,24.7011734 22.1269531,24.4003906 L21.5683594,21.7578125 L18.4316406,21.7578125 L17.8730469,24.4003906 C17.7871089,24.7441423 17.7727862,24.9661453 17.8300781,25.0664062 C17.9016931,25.1666672 18.066405,25.2024741 18.3242188,25.1738281 C18.5247406,25.1451821 18.6894525,25.2311188 18.8183594,25.4316406 C18.9186203,25.6035165 18.96875,25.8255195 18.96875,26.0976562 C18.96875,26.35547 18.9186203,26.577473 18.8183594,26.7636719 C18.6894525,26.9498707 18.5247406,27.0358074 18.3242188,27.0214844 C17.8515601,26.9641924 17.3287789,26.9355469 16.7558594,26.9355469 C16.1829398,26.9355469 15.6171903,26.9641924 15.0585938,27.0214844 C14.9010409,27.0358074 14.7792973,26.9498707 14.6933594,26.7636719 C14.6074214,26.577473 14.5644531,26.35547 14.5644531,26.0976562 C14.5644531,25.8255195 14.6074214,25.6035165 14.6933594,25.4316406 C14.7792973,25.2311188 14.9010409,25.1451821 15.0585938,25.1738281 C15.3164075,25.2024741 15.4954422,25.1738286 15.5957031,25.0878906 C15.695964,24.9876297 15.7890621,24.7584653 15.875,24.4003906 L18.1738281,13.8300781 C18.2597661,13.4147115 18.2812502,13.1712243 18.2382812,13.0996094 C18.1953123,13.0423174 18.0162776,13.0208333 17.7011719,13.0351562 L16.90625,13.0566406 C16.7057282,13.0709636 16.5481777,12.985027 16.4335938,12.7988281 C16.3190098,12.6126293 16.2617188,12.3906263 16.2617188,12.1328125 C16.2617188,11.8606757 16.3190098,11.6386727 16.4335938,11.4667969 C16.5481777,11.266275 16.7057282,11.1803384 16.90625,11.2089844 Z" id="A" fill="#000000"></path>
        </g>
    </g>
</svg>`), exp: "通常" },
        Small: { value: -1, gRatio: 1, icon:"data:image/svg+xml;charset=utf-8;base64," + btoa(`<?xml version="1.0" encoding="UTF-8"?>
<svg width="40px" height="40px" viewBox="0 0 40 40" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <!-- Generator: Sketch 43.2 (39069) - http://www.bohemiancoding.com/sketch -->
    <title>msize_small</title>
    <desc>Created with Sketch.</desc>
    <defs></defs>
    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="msize_small">
            <rect id="Rectangle-3" fill="#EFEFEF" x="0" y="0" width="40" height="40" rx="12"></rect>
            <path d="M20.5,15.8574219 L19.5507812,20.1992188 L21.4492188,20.1992188 L20.5,15.8574219 Z M17.96875,13.0800781 C18.214845,13.1035157 18.4726549,13.1152344 18.7421875,13.1152344 C18.9062508,13.1152344 19.1582014,13.1093751 19.4980469,13.0976562 L20.5527344,13.0800781 C20.7988294,13.0800781 21.0273427,13.1621086 21.2382812,13.3261719 C21.5078138,13.5371104 21.6894527,13.8535135 21.7832031,14.2753906 L23.875,23.8730469 C23.933594,24.1660171 24.0039058,24.3535152 24.0859375,24.4355469 C24.1679692,24.5175785 24.2968741,24.5410158 24.4726562,24.5058594 C24.6250008,24.4824218 24.7421871,24.5527336 24.8242188,24.7167969 C24.9062504,24.8574226 24.9472656,25.0390614 24.9472656,25.2617188 C24.9472656,25.4726573 24.9062504,25.6542961 24.8242188,25.8066406 C24.7421871,25.9589851 24.6250008,26.0292969 24.4726562,26.0175781 C24.0507791,25.9589841 23.5703152,25.9296875 23.03125,25.9296875 C22.5039036,25.9296875 22.0234397,25.9589841 21.5898438,26.0175781 C21.4023428,26.0292969 21.2558599,25.9589851 21.1503906,25.8066406 C21.0566402,25.6542961 21.0097656,25.4726573 21.0097656,25.2617188 C21.0097656,25.0390614 21.0566402,24.8574226 21.1503906,24.7167969 C21.2558599,24.5527336 21.4023428,24.4824218 21.5898438,24.5058594 C21.7773447,24.5410158 21.9414055,24.5117192 22.0820312,24.4179688 C22.2460946,24.3007807 22.2988284,24.1191419 22.2402344,23.8730469 L21.7832031,21.7109375 L19.2167969,21.7109375 L18.7597656,23.8730469 C18.6894528,24.1542983 18.6777341,24.3359371 18.7246094,24.4179688 C18.7832034,24.5000004 18.9179677,24.529297 19.1289062,24.5058594 C19.2929696,24.4824218 19.4277338,24.5527336 19.5332031,24.7167969 C19.6152348,24.8574226 19.65625,25.0390614 19.65625,25.2617188 C19.65625,25.4726573 19.6152348,25.6542961 19.5332031,25.8066406 C19.4277338,25.9589851 19.2929696,26.0292969 19.1289062,26.0175781 C18.7421856,25.9707029 18.3144555,25.9472656 17.8457031,25.9472656 C17.3769508,25.9472656 16.9140648,25.9707029 16.4570312,26.0175781 C16.3281244,26.0292969 16.228516,25.9589851 16.1582031,25.8066406 C16.0878903,25.6542961 16.0527344,25.4726573 16.0527344,25.2617188 C16.0527344,25.0390614 16.0878903,24.8574226 16.1582031,24.7167969 C16.228516,24.5527336 16.3281244,24.4824218 16.4570312,24.5058594 C16.6679698,24.529297 16.8144527,24.5058597 16.8964844,24.4355469 C16.978516,24.3535152 17.0546871,24.1660171 17.125,23.8730469 L19.0058594,15.2246094 C19.0761722,14.8847639 19.0937502,14.6855472 19.0585938,14.6269531 C19.0234373,14.5800779 18.8769544,14.5624999 18.6191406,14.5742188 L17.96875,14.5917969 C17.8046867,14.6035157 17.6757817,14.5332039 17.5820312,14.3808594 C17.4882808,14.2285149 17.4414062,14.0468761 17.4414062,13.8359375 C17.4414062,13.6132801 17.4882808,13.4316413 17.5820312,13.2910156 C17.6757817,13.1269523 17.8046867,13.0566405 17.96875,13.0800781 Z" id="A" fill="#000000"></path>
        </g>
    </g>
</svg>`), exp: "やや小" },
        Smaller: { value: -2, gRatio: 1, icon:"data:image/svg+xml;charset=utf-8;base64," + btoa(`<?xml version="1.0" encoding="UTF-8"?>
<svg width="40px" height="40px" viewBox="0 0 40 40" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <!-- Generator: Sketch 43.2 (39069) - http://www.bohemiancoding.com/sketch -->
    <title>msize_smaller</title>
    <desc>Created with Sketch.</desc>
    <defs></defs>
    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="msize_smaller">
            <rect id="Rectangle-3" fill="#EFEFEF" x="0" y="0" width="40" height="40" rx="12"></rect>
            <path d="M20,16.1113281 L19.2617188,19.4882812 L20.7382812,19.4882812 L20,16.1113281 Z M18.03125,13.9511719 C18.2226572,13.9694011 18.423176,13.9785156 18.6328125,13.9785156 C18.7604173,13.9785156 18.9563789,13.9739584 19.2207031,13.9648438 L20.0410156,13.9511719 C20.2324228,13.9511719 20.4101554,14.0149733 20.5742188,14.1425781 C20.7838552,14.3066414 20.9251298,14.5527327 20.9980469,14.8808594 L22.625,22.3457031 C22.6705731,22.5735688 22.7252601,22.7194007 22.7890625,22.7832031 C22.8528649,22.8470055 22.9531243,22.8652345 23.0898438,22.8378906 C23.2083339,22.8196614 23.2994788,22.8743483 23.3632812,23.0019531 C23.4270837,23.1113287 23.4589844,23.2526033 23.4589844,23.4257812 C23.4589844,23.5898446 23.4270837,23.7311192 23.3632812,23.8496094 C23.2994788,23.9680996 23.2083339,24.0227865 23.0898438,24.0136719 C22.7617171,23.9680987 22.3880229,23.9453125 21.96875,23.9453125 C21.5585917,23.9453125 21.1848975,23.9680987 20.8476562,24.0136719 C20.7018222,24.0227865 20.587891,23.9680996 20.5058594,23.8496094 C20.4329423,23.7311192 20.3964844,23.5898446 20.3964844,23.4257812 C20.3964844,23.2526033 20.4329423,23.1113287 20.5058594,23.0019531 C20.587891,22.8743483 20.7018222,22.8196614 20.8476562,22.8378906 C20.9934903,22.8652345 21.1210932,22.8424483 21.2304688,22.7695312 C21.3580736,22.678385 21.3990888,22.5371103 21.3535156,22.3457031 L20.9980469,20.6640625 L19.0019531,20.6640625 L18.6464844,22.3457031 C18.5917966,22.5644542 18.5826821,22.7057288 18.6191406,22.7695312 C18.6647138,22.8333337 18.7695304,22.8561199 18.9335938,22.8378906 C19.0611986,22.8196614 19.1660152,22.8743483 19.2480469,23.0019531 C19.3118493,23.1113287 19.34375,23.2526033 19.34375,23.4257812 C19.34375,23.5898446 19.3118493,23.7311192 19.2480469,23.8496094 C19.1660152,23.9680996 19.0611986,24.0227865 18.9335938,24.0136719 C18.632811,23.9772134 18.300132,23.9589844 17.9355469,23.9589844 C17.5709617,23.9589844 17.2109393,23.9772134 16.8554688,24.0136719 C16.7552078,24.0227865 16.6777346,23.9680996 16.6230469,23.8496094 C16.5683591,23.7311192 16.5410156,23.5898446 16.5410156,23.4257812 C16.5410156,23.2526033 16.5683591,23.1113287 16.6230469,23.0019531 C16.6777346,22.8743483 16.7552078,22.8196614 16.8554688,22.8378906 C17.0195321,22.8561199 17.1334632,22.8378909 17.1972656,22.7832031 C17.261068,22.7194007 17.3203122,22.5735688 17.375,22.3457031 L18.8378906,15.6191406 C18.8925784,15.3548164 18.9062501,15.19987 18.8789062,15.1542969 C18.8515624,15.1178384 18.7376312,15.1041666 18.5371094,15.1132812 L18.03125,15.1269531 C17.9036452,15.1360678 17.8033858,15.0813808 17.7304688,14.9628906 C17.6575517,14.8444004 17.6210938,14.7031258 17.6210938,14.5390625 C17.6210938,14.3658846 17.6575517,14.2246099 17.7304688,14.1152344 C17.8033858,13.9876296 17.9036452,13.9329426 18.03125,13.9511719 Z" id="A" fill="#000000"></path>
        </g>
    </g>
</svg>`), exp: "小" },
        Smallest: { value: -3, gRatio: 1, icon:"data:image/svg+xml;charset=utf-8;base64," + btoa(`<?xml version="1.0" encoding="UTF-8"?>
<svg width="40px" height="40px" viewBox="0 0 40 40" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <!-- Generator: Sketch 43.2 (39069) - http://www.bohemiancoding.com/sketch -->
    <title>msize_smallest</title>
    <desc>Created with Sketch.</desc>
    <defs></defs>
    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="msize_smallest">
            <rect id="Rectangle-3" fill="#EFEFEF" x="0" y="0" width="40" height="40" rx="12"></rect>
            <path d="M20.5,17.2382812 L19.8671875,20.1328125 L21.1328125,20.1328125 L20.5,17.2382812 Z M18.8125,15.3867188 C18.9765633,15.4023438 19.1484366,15.4101562 19.328125,15.4101562 C19.4375005,15.4101562 19.6054676,15.40625 19.8320312,15.3984375 L20.5351562,15.3867188 C20.6992196,15.3867188 20.8515618,15.4414057 20.9921875,15.5507812 C21.1718759,15.691407 21.2929684,15.9023423 21.3554688,16.1835938 L22.75,22.5820312 C22.7890627,22.7773447 22.8359372,22.9023435 22.890625,22.9570312 C22.9453128,23.011719 23.0312494,23.0273439 23.1484375,23.0039062 C23.2500005,22.9882812 23.3281247,23.0351557 23.3828125,23.1445312 C23.4375003,23.2382817 23.4648438,23.3593743 23.4648438,23.5078125 C23.4648438,23.6484382 23.4375003,23.7695307 23.3828125,23.8710938 C23.3281247,23.9726568 23.2500005,24.0195313 23.1484375,24.0117188 C22.8671861,23.9726561 22.5468768,23.953125 22.1875,23.953125 C21.8359357,23.953125 21.5156264,23.9726561 21.2265625,24.0117188 C21.1015619,24.0195313 21.0039066,23.9726568 20.9335938,23.8710938 C20.8710934,23.7695307 20.8398438,23.6484382 20.8398438,23.5078125 C20.8398438,23.3593743 20.8710934,23.2382817 20.9335938,23.1445312 C21.0039066,23.0351557 21.1015619,22.9882812 21.2265625,23.0039062 C21.3515631,23.0273439 21.460937,23.0078128 21.5546875,22.9453125 C21.664063,22.8671871 21.6992189,22.7460946 21.6601562,22.5820312 L21.3554688,21.140625 L19.6445312,21.140625 L19.3398438,22.5820312 C19.2929685,22.7695322 19.2851561,22.8906247 19.3164062,22.9453125 C19.3554689,23.0000003 19.4453118,23.0195313 19.5859375,23.0039062 C19.695313,22.9882812 19.7851559,23.0351557 19.8554688,23.1445312 C19.9101565,23.2382817 19.9375,23.3593743 19.9375,23.5078125 C19.9375,23.6484382 19.9101565,23.7695307 19.8554688,23.8710938 C19.7851559,23.9726568 19.695313,24.0195313 19.5859375,24.0117188 C19.3281237,23.9804686 19.0429703,23.9648438 18.7304688,23.9648438 C18.4179672,23.9648438 18.1093765,23.9804686 17.8046875,24.0117188 C17.7187496,24.0195313 17.652344,23.9726568 17.6054688,23.8710938 C17.5585935,23.7695307 17.5351562,23.6484382 17.5351562,23.5078125 C17.5351562,23.3593743 17.5585935,23.2382817 17.6054688,23.1445312 C17.652344,23.0351557 17.7187496,22.9882812 17.8046875,23.0039062 C17.9453132,23.0195313 18.0429685,23.0039065 18.0976562,22.9570312 C18.152344,22.9023435 18.2031248,22.7773447 18.25,22.5820312 L19.5039062,16.8164062 C19.5507815,16.5898426 19.5625001,16.4570314 19.5390625,16.4179688 C19.5156249,16.3867186 19.4179696,16.375 19.2460938,16.3828125 L18.8125,16.3945312 C18.7031245,16.4023438 18.6171878,16.3554693 18.5546875,16.2539062 C18.4921872,16.1523432 18.4609375,16.0312507 18.4609375,15.890625 C18.4609375,15.7421868 18.4921872,15.6210942 18.5546875,15.5273438 C18.6171878,15.4179682 18.7031245,15.3710937 18.8125,15.3867188 Z" id="A" fill="#000000"></path>
        </g>
    </g>
</svg>`), exp: "最小"},
      },
      nowMojisize: "Normal",
      homePageVisible: false,
      inited: false,
      uivis: true,
      slvis: false,
      browsevis: false,
      lastpage: false,
      pageSliderValue: 1,
      popupWidth: 0,
      popupHeight: 0,
      licenseShow: false,
      licenseDisplay: 0,
      aboutShow: false,
      aboutText: undefined,
      onegai:null,
      lastpageShow: false,
      helpSheetShow: false,
//
      saveContents: null,

      nowPageIndex:0,       // BookpageViewが管理

      layoutParams: {
        pageStart: 1,                       // レイアウト計算値
        numOfPages: 1,                      //                  〃
        authorName: '作者不詳',             //                  〃
        contentsTitle: '名称未設定',        //                  〃
        vertically: false,                  //                  〃
        pageFeedRight: false,               //                  〃
        numColumn: 37,                      //                  〃
        numLine: 40,                        //                  〃
        wpages: false,                      //                  〃
        letterFont: calcFont,               //                  〃
        letterVFont: vertFont,              //                  〃
        picCapFont: picCapFont,             //                  〃
        letterSize: 18,                     //                  〃
        bottomCorrection: 0,             //                  〃
        graphRatio: 1,                      //                  〃
        gapSize: Math.floor(18 * (charSpacing - 1) * 10) / 10,   //                〃
        lineHeight: 18 * lineSpacing,       //                  〃
        docWidth: 0,                        //                  〃
        docHeight: 0,                       //                  〃
        linesWidth: 0,                      //                  〃
        columnsWidth: 0,                    //                  〃
        contentsMargin: 0,                  //                  〃
        wpContentsWidth: 0,                 //                  〃
        appAreaAspect: 0,                   //                  〃
        offcvs: null,                       //                  〃
      },
      //
      topFiller: 10,                        // レイアウト計算値。利用はBook側のみ
      bottomFiller: 10,                     //                  〃
      goLeftBorder: 0,                      //                  〃
      goRightBorder:0,                      //                  〃
      uiToggleBorder:0,                     //                  〃
      //
      composed:{},
      dataLoaded: false,
      //
      paging: true,
      //
      updateUICounter: 0,
      leftBDisabled: false,
      rightBDisabled: false,
      jumpUIDisabled: false,
      //
      gaijiList: {},
      //
//       testSVG: `<?xml version="1.0" encoding="UTF-8"?>
// <svg width="50px" height="50px" viewBox="0 0 50 50" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
//     <title>GAIJI0</title>
//     <g id="GAIJI0" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
//         <path d="M0,26 L2,26 L2,48 L24,48 L24,50 L0,50 L0,26 Z M50,26 L50,50 L26,50 L26,48 L48,48 L48,26 L50,26 Z M50,24 L48,24 L48,2 L26,2 L26,0 L50,0 L50,24 Z M24,0 L24,2 L2,2 L2,24 L0,24 L0,0 L24,0 Z" id="Shape" fill="#FF0016"></path>
//         <path d="M14.35,25.95 C22.85,24.4287741 27.35,20.9 29.15,13.85 C29.5,12.5 29.55,12 29.7,9.5 L31.85,9.5 L31.85,19.95 C31.85,21.65 32.4,22.35 33.95,22.55 C34.8235294,22.6470588 35.6173875,22.7441176 39.3599875,22.749743 L39.7,22.75 C42.8,22.75 44.95,22.55 46,22.3 C46.85,22.1 47.35,21.55 47.35,20.95 C47.35,20.3 47,20 46.05,19.7 C45.5,19.55 45.25,19.3 45.25,18.85 L45.25,18.15 L45.55,12.95 L44.8,12.9 C44,15.5 43.6,16.6 43.05,17.9 C42.3,19.6 42.3,19.6 41.8,19.75 C41.3695652,19.8934783 41.520983,20.0369565 39.6982576,20.0491617 L39.45,20.05 C37.5,20.05 36.2,19.95 35.9,19.9 C35.25,19.75 35.15,19.6 35.15,18.8 L35.15,9.5 L39.85,9.5 C38.65,12.95 38.5,13.2 37.55,15 L37.95,15.35 C40.35,13.5 41.4,12.6 43,10.9 C43.2,10.85 43.95,10.7 45.25,10.45 C45.85,10.35 46.35,10.2 46.55,10.05 C46.65,9.95 46.75,9.85 46.75,9.75 C46.75,9.55 46.6,9.35 46.25,9.05 C44.5,7.5 43.9,7.05 41.95,5.7 C40.95,6.8 40.7,7.15 39.85,8.35 L26.35,8.35 L26.35,3.55 C28.15,3 28.8,2.65 28.8,2.2 C28.8,2 28.6,1.8 28.2,1.65 C27.65,1.45 27.45,1.45 22.6,1 C22.8,2.35 22.85,2.6 22.85,4.6 L22.85,8.35 L9.15,8.35 C9.3,7.05 9.3,6.45 9.35,4.8 L8.6,4.8 C8.1,8.25 6.6,10.9 4.25,12.5 C3.2,13.25 3,13.5 3,14.2 C3,14.6 3.35,15.5 3.75,16.15 C4.05,16.7 4.35,16.9 4.75,16.9 C6.75,16.9 8.35,14.2 9.05,9.5 L26.25,9.5 C26,13.6 25.9453565,15.45 24.2453565,17.9 C21.6453565,21.5 19.85,24.05 13.9,25.05 L14.35,25.95 Z" id="Path" fill="#000000" fill-rule="nonzero"></path>
//         <path d="M10,48.5 C10.45,48.5 11.3,48.4 11.9,48.35 C12.35,48.25 12.5,48.1 12.5,47.55 L12.45,39.45 L12.5,35.25 L12.5,25.35 C13.75,25 14.25,24.7 14.25,24.25 C14.25,23.85 13.6,23.65 11,23.25 C14,19.4 15,17.95 16.4,15.4 L17.35,15.4 C18.3,15.4 19.1,15.1 19.1,14.75 C19.1,14.35 18.55,14 16.3,13.1 C15.7,12.9 14.75,12.5 13.6,12 C12,16.6 11.6,17.5 9.35,21.2 C6.75,25.5 5.45,27.25 1,32.4 L1.65,32.85 C4.85,30.35 6.2,29 9.25,25.35 L9.3,34.4 C9.3,40.8 9.3,40.8 9.1,47.7 L9.1,47.8 C9.1,48.3 9.35,48.5 10,48.5 Z" id="Path" fill="#000000" fill-rule="nonzero"></path>
//         <path d="M38.6,26 L40.5,24 L41.0856445,24.3289063 C42.3414063,25.0398438 42.89375,25.40625 44.25,26.5 C44.4,26.65 44.45,26.75 44.45,26.85 C44.45,27.25 43.75,27.65 42.4,27.9 L41.9366255,28.8270662 C39.3743827,33.9070988 37.8527778,36.1055556 35.35,38.75 C39.4964286,41.4982143 42.5735332,42.8051658 47.2263962,43.7019884 L47.75,43.8 L47.65,44.4 C46.5,44.5 46,44.7 45.35,45.25 C44.65,45.85 44.4,46.4 44.1,47.6 L43.0858092,47.1300996 C38.6564209,45.0403092 35.9965517,43.2568966 33.25,40.65 C32.35,41.45 30.55,42.7 29,43.6 C25.2827586,45.7724138 22.031629,47.012604 16.7713969,48.1306409 L16.2,48.25 L16,47.6 L17.3469889,47.0690429 C23.1985279,44.7427944 26.5970335,42.6850232 29.6720335,40.2157051 C32.7470335,37.7463869 36.0507889,33.5840524 38.2193926,28.0156741 L38.6,27.1 L19.5,27.1 C19.1333333,27.1 18.8333333,27.1222222 18.437037,27.1666667 L17.75,27.25 L17.45,25.5 C18.825,25.8208333 20.2,25.9736111 21.2283854,25.9968461 L21.5,26 L38.6,26 Z" id="Path" fill="#000000" fill-rule="nonzero"></path>
//     </g>
// </svg>`,
    };
  },
  created() {
    debugOut = this.$root.$options.debugOut

    this.fillerLimit = 0.566   //0.566 新書版の比率
    this.wpagesLimit = 1.5
    this.wpagesLimitV = 0.5
    this.contentsMargin = 0.1
    this.letterSize = 18
    this.graphRatio = 1
    this.letterFont = calcFont
    this.letterVFont = vertFont
    this.picCapFont = picCapFont
    this.pageData = []
    this.initialIndex = null
    this.resourcePath = null
    this.workTimestamp = 0
    this.tryPrivate = false

    // this.viewWidth = this.documentAreaWidth;
    // this.viewHeight = this.documentAreaHeight;
    let host = (location.hostname === "localhost") ? "Local" : "Web"
    console.log(`Start... ちょい読み （${host} -- ${this.$root.$options.cyappVersion}）`)
    if (debugOut) {console.log(`book view - ${this.documentAreaWidth} x ${this.documentAreaHeight}`)}
  },
  async mounted() {
    this.$refs.bookpage.setLayoutConst({
      tentativeSize: tentativeSize,
      rubySize: rubySize,
      charSpacing: charSpacing,
      lineSpacing: lineSpacing,
      hantWidthRatio: hantWidthRatio,
      rubyRatio: rubyRatio,
      subjectRatio: subjectRatio,
      drawTextBaseline: drawTextBaseline,
      tagControlStr: tagControlStr,
    },LineStyle,WordType,WordTypeMask,PropFlag,PictureFlags,NombreMode,SpecialLineIndex,gaijiArea)
    let query = Object.assign({}, this.$route.query);
    this.nowEmail = query.userid || null
    this.tryPrivate = this.nowEmail !== null
    this.authDisp = this.tryPrivate
    this.queryData = query;
    let authorId = Number(query.author)
    let contentsId = Number(query.record)
    let displayIndex = Number(query.index)
    let openPage = query.openPage
    let lastContents = (this.saveContents) ? this.saveContents['lastContents'] : null
    if (isNaN(authorId)) {
      if (lastContents) {
        authorId = Number(lastContents['author']);
        contentsId = Number(lastContents['contents']);
        displayIndex = Number(lastContents['newIndex']);
      } else {
        contentsId = NaN;
        displayIndex = NaN;
      }
    } else {
      if (isNaN(contentsId)) {
        if (this.saveContents) {
          let info = this.saveContents[authorId.toString()];
          if (info) {
            contentsId = Number(info[contentsId.toString()]);
            displayIndex = Number(info[contentsId.toString()]);
          }
        }
      }
    }
    this.authorId = isNaN(authorId) ? 0 : authorId
    this.contentsId = isNaN(contentsId) ? 0 : contentsId
    this.displayIndex =  isNaN(displayIndex) ? 0 : displayIndex
    this.initialIndex = isNaN(displayIndex) ? null : displayIndex
    this.privated = this.tryPrivate
    this.storeInfo();
    gtag('config', 'UA-149134194-1', {'page_path': `cyapp/?author=${this.authorId}&record=${this.contentsId}${this.privated ? '&dev=1' : ''}`})
    if (debugOut) {
      console.log(`$root:${this.$root}`)
      console.log(`$parent:${this.$parent}`)
      console.log(
          `author:${query.author} -> ${this.authorId} record:${query.record} -> ${this.contentsId} index:${query.index} -> ${this.displayIndex}`
      )
    }

    // let stores = {
    // 	'amazon':{'url':'','name':'Amazon','image':'af_banner/ama_middle.png','imageWidth':168},
    // };
    // this.buyStores = stores;
    window.addEventListener('resize', this.handleResize)
    this.pageNumberToSliderValue(this.nowPageIndex)

    // const sleep = (sec) => {
    //   return new Promise((resolve, reject) => {
    //     setTimeout(resolve, sec*1000)
    //     //setTimeout(() => {reject(new Error("エラー！"))}, sec*1000);
    //   })
    // }
    const fontCheck = async () => {
      while (this.fontActive === false) {
        await this.sleep(1)
      }
      if (this.fontActive === true) {
        return
      }
      throw new Error("Font Inactive!")
    }
    this.affiList = []
    let workInfo = null
    const loadData = async (aId,cId) => {
      this.homePageVisible = false
        this.lastMessage = null
        this.affiList = []
        if (debugOut) {console.log(`loadData ${aId},${cId}`)}
        let result = await this.getResourceURL(aId,cId)
        if (result.success) {
          this.resourcePath = result.result
          if (debugOut) {console.log(this.resourcePath)}
          this.workTimestamp = Number(result.timestamp)
          let response =
              this.tryPrivate   ? await this.workInfoLoad().catch(e => {throw Error(e)})
                                : await this.loadFromServer(infoFile).catch(e => {throw Error(e)})
          if (response.success) {
            workInfo = JSON.parse(response.result)
            this.lastMessage = this.detectLinks(workInfo['salesTalk'])
            this.onegai = workInfo['onegai'] || null
            if (workInfo['affiliateAmazon']) {
              this.affiList.push({
                pid: workInfo['affiliateAmazon'],
                name: workInfo['affiAmaName'] || "Amazon",
                site: 0
              })
            }
            if (workInfo['affiliateKindle']) {
              this.affiList.push({
                pid: workInfo['affiliateKindle'],
                name: workInfo['affiKinName'] || "Kindle",
                site: 1
              })
            }
            if (workInfo['affiliateRakuten']) {
              this.affiList.push({
                pid: workInfo['affiliateRakuten'],
                name: workInfo['affiRakName'] || "楽天ブックス",
                site: 10
              })
            }

            if (debugOut) { console.log(workInfo['aboutWork'])}
            this.aboutText = [
              {
                styles: null,
                title: workInfo['title'],
                html: this.detectLinks(workInfo['aboutWork'])
              },
              {
                styles: null,
                title: workInfo['author'],
                html: this.detectLinks(workInfo['aboutAuthor'])
              },
            ]
          } else {
            throw Error(response)
          }
          let taggedFileName = taggedFile
          if (workInfo.taggedTextZlib) {
            taggedFileName += '.zlib'
          }
          response = await this.loadFromServer(taggedFileName).catch(e => {throw Error(e)})
          if (response.success) {
            let jsonText = response.result
            if (workInfo.taggedTextZlib) {
              // console.log(jsonText)
              let expanded = zlib.inflateSync(new Buffer(jsonText,'base64'))
              jsonText = expanded.toString('utf8')
            }
            let tmpComposed = JSON.parse(jsonText)
            if(!tmpComposed.vers) {
              // {"letter":"-","pictureTag":{"picNumber":0,"picCaption":null},"lineStart":null,"dotStart":null,"strikeStart":null,"type":1048576,"typeLength":1,"typeWord":null,"typeWordWidths":null,"ruby":null,"width":0}
              tmpComposed = null
              let newJson = response.result
              let tags = [
                ['letter','l'],
                ['pictureTag','pt'],
                ['lineStart','ls'],
                ['dotStart','ds'],
                ['strikeStart','ss'],
                ['type','t'],
                ['typeLength','tl'],
                ['typeWord','tw'],
                ['typeWordWidths','t2'],
                ['ruby','r'],
                ['width','w'],
              ]
              for (let t of tags) {
                newJson = newJson.replace(new RegExp(`"${t[0]}":`,'gi'), `"${t[1]}":`)
              }
              tmpComposed = JSON.parse(newJson)
              tmpComposed.contents.forEach((c, cidx, carr) => {
                if (!c.line) return
                c.line.forEach((l,lidx,larr) => {
                  if (l.r) {
                    l.r.ruby = l.r.r
                    l.r.width = l.r.w
                    delete l.r.r
                    delete l.r.w
                  }
                })
              })
              tmpComposed.vers = 1.1
            }
            // if (debugOut) {
            //   console.log('gaiji setup')
            //   let svgImage = await this.svgToImage(this.testSVG)
            //   this.gaijiList = {
            //       '\u{E000}': {
            //         glyph:svgImage,
            //       },
            //   }
            //   console.log('gaijiList')
            //   console.log(svgImage)
            // }
            this.gaijiList = {}
            await this.loadFromServer(gaijiListFile + (this.privated ? '' : '.zlib')).then(async (response) => {
              if (debugOut) {console.log('gaiji setup')}
              let expanded = ''
              if (this.privated) {
                expanded = response.result
              } else {
                expanded = zlib.inflateSync(new Buffer(response.result, 'base64'))
                expanded = expanded.toString('utf8')
              }
              try {
                let obj = JSON.parse(expanded)

                let list = {}
                for (let value of obj) {
                  let img = await this.svgToImage(value.glyph)
                  if (img) {
                    list[String.fromCodePoint(value.uc)] = {
                      size: value.size || [1, 1],
                      glyph: img,
                      hex: value.hex
                    }
                  }
                }

                this.gaijiList = list
                if (debugOut) {console.log('外字リスト読込完了')}
              } catch (e) {
                if (debugOut) {console.log('外字パース失敗')}
              }

            }).catch(e => {
              if (debugOut) {console.log(`外字ファイル無し(${JSON.stringify(e)})`)}
            })


            this.composed = tmpComposed
            this.composed['author'] = workInfo.author
            this.composed['title'] = workInfo.title
            this.dataLoaded = true
            //this.composed = require('@/assets/testdata/composed')
          } else {
            throw Error(response)
          }
          return
        } else {
          throw Error(result.message)
        }
    }

    // サーバーからコンポーズドデータを読み込み、Webフォント読み込みチェック
    const prepareBook = async () => {
        try {
          await Promise.all([fontCheck(),loadData(this.authorId,this.contentsId)])
          await this.measureBaselineOffset()
          this.affiset()
          this.layoutCalc()
          setTimeout(() => {
            this.$refs.bookpage.handleResize()
          },3000)
          return true
        } catch(e) {
          console.log(e)
          console.log(`データの読み込みに失敗しました。( author ID:${this.authorId} / work ID:${this.contentsId} )`)
          await DialogHelper.modalErrorSync(this, {
            // message: (this.$store.state.fontActive ? '' : 'Webフォント') + ((this.dataLoaded || this.$store.state.fontActive) ? '' : 'と') + (this.dataLoaded ? '' : 'ブックデータ') + (`が読み込めませんでした。`)
            message: `データの読み込みに失敗しました。\n( author ID:${this.authorId} / work ID:${this.contentsId} )`
          })
          return false
        }
    }


    if(!(this.authorId === 0 && this.contentsId === 0) && await prepareBook()) {

      this.inited = true
      this.uivis = false
      if (!this.$store.state.restFontLoaded) {        //ページ描画に影響しないWebフォントはここで読み込む
        WebFontLoader.load({
          google: {
            families: ['Noto Sans JP', 'M PLUS Rounded 1c']       //
          },
          // custom: {
          //   families: ['Noto-Serif-JPVO', 'Noto-Sans-JPVO']
          // },
          active: () => {
            this.$store.commit('setRestFontLoaded', true)
          },
        })
      }
      //
      this.createPageTitle({
        meta: {
          title: `${this.layoutParams.contentsTitle}`,
          desc: `${this.layoutParams.contentsTitle}（${this.layoutParams.authorName}：著）のサンプル本です。商品書籍とはレイアウト等が異なっています。`
        }
      })
      this.$nextTick(() => {
        this.licenseShow = (openPage === 'license')
        this.aboutShow = (openPage === 'about')
      })
    } else {
      this.homePageVisible = true
      this.paging = false
      this.createPageTitle({
        meta: {
          title: `ちょい読み`,
          desc: `サンプル本試し読みサービス`
        }
      })
      // this.$router.replace(null)
      window.history.replaceState(null,null,location.pathname)
      this.$nextTick(() => {
        if (debugOut) {console.log(`openPage:${openPage}`)}
        this.licenseDisplay = (openPage === 'license') ? 1 : 0
      })
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },
  watch: {
    saveContents(nv) {
      if (localStorage.choiyomi_saveContents) {
        this.saveContents = localStorage.choiyomi_saveContents
        if (debugOut) {console.log(`localStorage reading ${this.saveContents}`)}
      }
      if (nv) {
        localStorage.choiyomi_saveContents = nv
      } else {
        localStorage.removeItem('choiyomi_saveContents')
      }
    },
    documentAreaWatcher(nv) {
      if (debugOut) {console.log(`detect document area resize [${this.updateUICounter}]`)}
      this.$nextTick(() => {
        this.updateUICounter += 1
      })
    },
    nowPageIndex(nv) {
      if (debugOut) {console.log(`nowPageIndex Change! : ${nv}`)}
    },
    $route(nv, ov) {
      if (debugOut) {console.log(`$route change!`);}
      this.makeBookmarkURL()
    },
  },
  computed: {
    updateUI00() {return this.updateUICounter},
    updateUI01() {return this.updateUICounter + 100},
    // updateUI02() {return this.updateUICounter + 200},
    // updateUI03() {return this.updateUICounter + 300},
    // updateUI04() {return this.updateUICounter + 400},
    // updateUI05() {return this.updateUICounter + 500},
    papiDir() {
      return this.$root.$options.commandPath
    },
    baseDir() {
      return this.$root.$options.serverPath
    },
    dataURL() {
      return this.baseDir + this.$root.$options.dataDir
    },
    dataPathRelative() {
      return '../' + this.$root.$options.dataDir
    },
    publishedDir() {
      return this.dataURL + (this.resourcePath ? '/' + this.resourcePath : "")
    },
    loadingMessage() {
      if (!this.paging && this.$store.state.fontActive && this.dataLoaded) return null
      return `Web Font load : ${this.$store.state.restFontLoaded ? '✓' : '...'}\nBook Data load : ${this.dataLoaded ? '✓' : '...'}`
    },
    iconColor: function() {
      return this.defUIIconColor;
    },
    environmentReport: function() {

      return `モニター解像度：${screen.width} x ${screen.height}
モニター利用可能領域：${screen.availWidth} x ${screen.availHeight}
ウインドウ表示領域幅：${window.innerWidth} x ${window.innerHeight} （※スクロールバーを含む）
ウインドウ外枠幅：${window.outerWidth} x ${window.outerHeight}
ドキュメント領域幅：${document.body.clientWidth} x ${document.body.clientHeight}
ドキュメント表示領域：${document.documentElement.clientWidth} x ${document.documentElement.clientHeight}
アプリ表示領域:${this.documentAreaWidth} x ${this.documentAreaHeight}
ピクセル倍率：${window.devicePixelRatio} 倍
※xペアーの情報は 横ｘ縦 `;
    },
    licenseText() {
      return [
        {
          styles: {},
          title: `ちょい読み （Web ${this.$root.$options.cyappVersion}）`,
          message:`Copyright (c) 2019-present, Choiyomi Team

ちょい読みは、各作品の著作権者より提供されたデータ（テキスト、画像等）を用い、独自のレンダリングシステムで簡易電子書籍化して閲覧できるようにしています。
従って、実際に市販されている書籍等とはフォーマットが異なっています。予めご了承の上、お楽しみください。
`
        },
        {
          styles: {},
          title: `著作権について`,
          message:`本サービスでに掲載されている全てのコンテンツは、それぞれの作者及び出版社、ベンダーが所有しています。書面による許可なく、個人的な目的以外で使用することは禁止されています。
          `
        },
        {
          styles: {},
          title: `プライバシーポリシー`,
          html: `当サービスでは、コンテンツ提供においてCookie（クッキー）を利用する場合があります。
Cookieとは、アクセスした際ブラウザー側に保存される情報ですが、ユーザーの皆様のお名前やメールアドレス等の個人情報は含まれません。
ブラウザ側の設定により、Cookieを使用しないようにすることも可能です。
当サービスでは、ユーザーのコンテンツ利用状況を解析するためにアクセス解析サービスを利用しています。アクセス解析においても、個人を特定できる情報は収集いたしません。
当サービスでは、独自実装のものの他、以下のアクセス解析サービスも利用しています。

<a href="https://www.google.com/intl/ja_jp/analytics" target="_blank" rel="noopener noreferrer" style="color: #000;text-decoration: none;">グーグルアナリティクス</a>

※プライバシーポリシーの変更について
当サービス、個人情報に関して日本の法令を遵守し、内容を適宜見直しその改善に努めます。

`
        },
        {
          styles: {},
          title: `免責事項`,
          html:`当サービス利用のコンテンツ・情報につきまして、可能な限り正確な情報を掲載するよう努めておりますが、誤情報が入り込んだり、情報が古くなっていることもございます。
当サイトに掲載された内容によって生じた損害等の一切の責任を負いかねますのでご了承ください。

本サービスは、一部の機能を除き、ユーザーの方々には無料で提供されています。当サービスで提供されるコンテンツのURLを利用したウェブサイト、Blog、SNS等の閲覧や情報収集については、情報がユーザーの需要に適合するものか否か、情報の保存や複製その他ユーザーによる任意の利用方法により必要な法的権利を有しているか否か、著作権、秘密保持、名誉毀損、品位保持および輸出に関する法規その他法令上の義務に従うことなど、ユーザーご自身の責任において行っていただきますようお願いいたします。
当サービスの御利用につき、何らかのトラブルや損失・損害等につきましては一切責任を問わないものとします。
当サービスが提供／紹介しているコンテンツの合法性、正確性、道徳性、最新性、適切性、著作権の許諾や有無など、その内容については一切の保証を致しかねます。
当サービスからのリンクやバナーなどによって他のサービス、サイトに移動された場合、移動先で提供される情報、サービス等について一切の責任を負いません。
`
        },
        {
          styles: {},
          title: `連絡先`,
          html:`お問い合わせは下記メールアドレスにて受け付けております。
          ちょい読み管理者：<a href="mailto:cymanage@choiyomi.info?subject=[ちょい読み]問い合わせ" style="text-decoration: none;" >cymanage@choiyomi.info（メール起動）</a>
`
        },
        {
          styles: {},
          title: 'The MIT License (MIT)',
          html: ` <span style="display: inline-block; width: 12em;">'Vue.js'</span>Copyright (c) 2013-present, Yuxi (Evan) You
 <span style="display: inline-block; width: 12em;">'vue-router'</span>Copyright (c) 2013-present, Evan You
 <span style="display: inline-block; width: 12em;">'Vuex'</span>Copyright (c) 2015-present, Evan You
 <span style="display: inline-block; width: 12em;">'axios'</span>Copyright (c) 2014-present, Matt Zabriskie
 <span style="display: inline-block; width: 12em;">'VueLocalStorage'</span>Copyright (c) 2016 Alexander Avakov
 <span style="display: inline-block; width: 12em;">'vue-virtual-scroller'</span>Copyright (c) 2017-present, Akryum

Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:
The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
`
        },
      ]

    },
    pageNumber: function() {
      return parseInt(this.layoutParams.pageFeedRight ? (this.layoutParams.numOfPages - this.pageSliderValue) : this.pageSliderValue) + this.layoutParams.pageStart;
    },
    workTimestamp: {
      get() { return this.$store.state.workTimestamp },
      set(value) { this.$store.commit('setWorkTimestamp',value) },
    },
    resourcePath: {
      get() { return this.$store.state.resourcePath },
      set(value) { this.$store.commit('setResourcePath',value) },
    },
    fontActive: {
      get() { return this.$store.state.fontActive },
      set(value) { this.$store.commit('setFontActive',value) },
    },
    notResigingDoc: {
      get() { return this.$store.state.notResigingDoc },
      set(value) { this.$store.commit('setNotResigingDoc',value) },
    },
    ...mapState([
      'nowLockKey',
      'documentAreaWidth',
      'documentAreaHeight',
      'documentAreaWatcher',
      'appReferrer',
      'restFontLoaded',
    ]),
  },
  methods: {
    sleep(time) {
      return new Promise(resolve => setTimeout(resolve, time))
    },
    async affiLinkClick(a,p) {
      if (debugOut) {console.log(`affiliate link click : ${a}`)}
      if (!await DialogHelper.modalConfirmSync(this,{message:'商品ページを開きます'})) { return }
      if (a !== "Rakuten") {
        p = this.$root.$options.amaAffiUrl + `${p}/${amsAsoID}`
      }
      let result = window.open(p, "_blank", "menubar=0")
    },
    async openWork(a,w,t) {
      if (debugOut) {console.log(`open author:${a} work:${w}`)}
      if ((!a && !w) || !t) {
        DialogHelper.modalError(this,{message:'正常なデータが取得できませんでした。'})
        return
      }
      if (!await DialogHelper.modalConfirmSync(this,{message:`ちょい読みで「${t}」を開きます`})) { return }
      let u = location.origin + `/cyapp/?author=${a}&record=${w}`
      if (debugOut) {console.log(`open url: ${u}`)}
      window.location.href = u
      // this.$router.replace({ path: '/', query: {author:a, record:w} })
    },
    detectLinks(string) {
      if (!string) return string
      string = string.replace(/((http(s)?|mailto):\/\/[a-zA-Z0-9-.!_'()*;/?:@&=+$,%#]+)/gi, "@@*@@<a href='$1' target='_blank' rel='noopener noreferrer'>$1</a>@@*@@");
      let list = string.split('@@*@@')
      list = list.map((value) => {
        if (value.startsWith('<a href=')) { return value}
        return this.escape_html(value)
      })
      return list.join('')
    },
    escape_html(string) {
      if (typeof string !== 'string') {
        return string;
      }
      return string.replace(/[&'`"<>]/g, function (match) {
        return {
          '&': '&amp;',
          "'": '&#x27;',
          '`': '&#x60;',
          '"': '&quot;',
          '<': '&lt;',
          '>': '&gt;',
        }[match]
      });
    },
    getResourceURL(naID,workID) {
      return new Promise(async (resolve, reject) => {
        if (naID === null || workID === null) {
          return resolve({success:false, result:'No data'})
        }
        let privateName = ""
        if (this.tryPrivate) {
          if (debugOut) {console.log('wait get lock key')}
          const waitLockauth = async () => {
            while (this.nowLockKey === null) {
              await this.sleep(1)
            }
          }
          await waitLockauth()
          if (debugOut) {console.log(`lock key get. (${this.nowLockKey})`)}
          if (this.nowLockKey !== "") {
            privateName = `&private=${encodeURIComponent(this.nowLockKey)}`
          }
        }
        let ref = encodeURIComponent(this.appReferrer)
        if (debugOut) {console.log(`REFERRER:${ref}`)}
        let plain = `${naID}:${workID}:BKDT:${this.tryPrivate ? "Lock" : "Pub"}:Book${this.$root.$options.cyappVersion}|${ref}`
        let encrypted = crypto.publicEncrypt(publicKey, Buffer.from(plain,'utf-8')).toString('base64')
        let xhr = new XMLHttpRequest()

        // if (progressHandler) xhr.onprogress = progressHandler
        xhr.onload = (e) => {
          // if (debugOut) {console.log(`${e.type}: ${e.loaded} bytes transferred`)}
          let json = JSON.parse(xhr.responseText)
          // json.xhr = xhr
          // if (debugOut) {console.log(json)}
          resolve(json)
        }
        xhr.onerror = (e) => { reject({success:false, message:'Error detected!', error:e})}
        xhr.onabort = (e) => { reject({success:false, message:'Aborted!', error:e})}
        xhr.ontimeout = (e) => {reject({success:false, message:'Timeout detected!', error:e})}

        xhr.open('POST', `${this.papiDir}/getaddress.php`, true)
        xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded')
        xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest')
        xhr.send(`encData=${encodeURIComponent(encrypted)}${privateName}`)
      })
    },
    async measureBaselineOffset() {
      let ratio = 1
      if (drawTextBaseline === 'bottom') {
        let cv = document.createElement('canvas')
        cv.width = 100
        cv.height = 100
        let getH = 100
        let ctx = cv.getContext('2d')
        ctx.font = `${getH}px ${this.letterFont}`
        ctx.textBaseline = drawTextBaseline
        ctx.fillText('⏊▟⃞⿰', 0, getH)
        let countH = getH * 4
        let founded = 0
        let alpha = []
        for (let sx = 0; (founded === 0) && (sx < cv.width); sx++) {
          alpha = []
          let pixels = ctx.getImageData(sx, 0, 1, getH)
          // if (debugOut) {console.log(`Baseline around pixels:${pixels.data}`)}
          for (let i = 3; i < countH; i += 4) {
            let a = pixels.data[i]
            founded |= a
            alpha.push(a)
          }
          if (debugOut) {
            console.log(`Pixels scan x:${sx} ---> ${founded}`)
          }
        }
        if (founded === 0) {
          alpha = []
        } else {
          let i = getH - 1
          for (; i >= 0; i--) {
            if (alpha[i] !== 0) break
          }
          ratio = Math.ceil((i + 1) / (getH * 0.05)) * 5 / 100      //0.05単位
        }

        if (debugOut) {console.log(`Pixels contents bottom ratio:${ratio}\nPixels RGBA:${alpha}`)}
      }
      this.layoutParams.bottomCorrection = (Math.ceil((1 - ratio) * 100) / 100)
    },
    async loadFromServer(name) {
      return new Promise(async (resolve, reject) => {
        let urlStr = this.publishedDir + '/' + name
        let xhr = new XMLHttpRequest()
        xhr.onload = (e) => {
          if ((xhr.readyState === 4) && (xhr.status === 200)) {
             resolve({success:true, result:xhr.responseText})
          } else {
            reject({success:false, message:`Status Error (code = ${xhr.status})`, error:e})
          }
        }
        xhr.onerror = (e) => { reject({success:false, message:'Error detected!', error:e})}
        xhr.onabort = (e) => { reject({success:false, message:'Aborted!', error:e})}
        xhr.ontimeout = (e) => {reject({success:false, message:'Timeout detected!', error:e})}

        xhr.open('GET', urlStr, true)
        xhr.withCredentials = true
        // xhr.responseType = 'text'
        xhr.setRequestHeader('Content-Type', 'text/plain')
        xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest')
        xhr.setRequestHeader('Pragma', 'no-cache')
        xhr.setRequestHeader('Cache-Control', 'no-cache')
        // xhr.setRequestHeader('If-Modified-Since', 'Thu, 01 Jun 1970 00:00:00')
        xhr.send(null)
      })
    },
    workInfoLoad() {
      return new Promise(async (resolve, reject) => {
        let pathStr = `${this.dataPathRelative}/${this.resourcePath}/${this.nowLockKey}${infoFile}`
        let xhr = new XMLHttpRequest()
        xhr.onload = (e) => {
          if ((xhr.readyState === 4) && (xhr.status === 200)) {
            resolve({success:true, result:JSON.parse(xhr.responseText)})
          } else {
            reject({success:false, message:'Unsuccesful get work info!', error:e})
          }
        }
        xhr.onerror = (e) => { reject({success:false, message:'Error detected!', error:e})}
        xhr.onabort = (e) => { reject({success:false, message:'Aborted!', error:e})}
        xhr.ontimeout = (e) => {reject({success:false, message:'Timeout detected!', error:e})}

        xhr.open('POST', `${this.papiDir}/workinfoget.php`, true)
        // xhr.withCredentials = true
        // xhr.responseType = 'text'
        xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded')
        xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest')
        xhr.setRequestHeader('Pragma', 'no-cache')
        xhr.setRequestHeader('Cache-Control', 'no-cache')
        // xhr.setRequestHeader('If-Modified-Since', 'Thu, 01 Jun 1970 00:00:00')
        xhr.send(`path=${encodeURIComponent(pathStr)}`)
      })
    },
    pagesUpdate: function(dispPageIndex) {
      this.lastpage = dispPageIndex === this.layoutParams.numOfPages - 1
      if (this.$refs.goRight && this.$refs.goLeft) {
        let prevButton = this.layoutParams.pageFeedRight ? this.$refs.goRight : this.$refs.goLeft
        let nextButton = this.layoutParams.pageFeedRight ? this.$refs.goLeft : this.$refs.goRight
        prevButton.isDisable = dispPageIndex <= 0
        nextButton.isDisable = dispPageIndex >= this.layoutParams.numOfPages          //最後のページでも有効
      }
      if (this.layoutParams.vertically) {
        this.rightBDisabled = dispPageIndex <= 0
        this.leftBDisabled = dispPageIndex >= this.layoutParams.numOfPages          //最後のページでも有効
      } else {
        this.leftBDisabled = dispPageIndex <= 0
        this.rightBDisabled = dispPageIndex >= this.layoutParams.numOfPages          //最後のページでも有効
      }
      this.jumpUIDisabled = this.layoutParams.numOfPages <= 0
      if (this.$refs.jumpUIDisplay) {
        this.$refs.jumpUIDisplay.isDisable = this.jumpUIDisabled
      }
      this.pageNumberToSliderValue(dispPageIndex)
      if (this.initialIndex) {
        let tmpIndex = this.initialIndex - this.pageData[dispPageIndex].start
        if ((0 <= tmpIndex) && (tmpIndex < this.pageData[dispPageIndex].length)) return
        this.initialIndex = null
      }
      this.makeBookmarkURL(this.pageData[dispPageIndex].start)
    },
    svgbClick: function() {
      if (debugOut) {console.log("click!!");}
      this.aboutShow = true
    },
    svgbTbClick: function() {
      if (debugOut) {console.log("tclick!!");}
      this.licenseShow = true
    },
    showLastpage() {
      this.lastpageShow = true
    },
    goLeft: function() {
      if (this.lastpage && this.layoutParams.pageFeedRight) {
        this.lastpageShow = true
        return
      }
      this.$refs.bookpage.pageFlip('right')
    },
    goRight: function() {
      if (this.lastpage && !this.layoutParams.pageFeedRight) {
        this.lastpageShow = true
        return
      }
      this.$refs.bookpage.pageFlip('left')
    },
    pageSliderChange: function () {
      this.$refs.bookpage.pageUpdate(this.pageNumber - 1);
    },
    jumpUIDisplay: function() {
      this.slvis = true;
    },
    pulldownAction: function(k) {
      if (this.buyStores === null) return
      let result = window.open(this.buyStores[k].url, "_blank", "menubar=0")
      if (debugOut) {
        console.log(
            `pulldown select '${k}' \n open '${this.buyStores[k].url}' ... ${
                result == null ? "failed." : "success."
            }`
        )
      }
    },
    lastpageBuyAction: function(k) {
      this.lastpageShow = false
      let result = window.open(this.buyStores[k].url, "_blank", "menubar=0")
      if (debugOut) {
        console.log(
            `lastpage buy select '${k}' \n open '${this.buyStores[k].url}' ... ${
                result == null ? "failed." : "success."
            }`
        )
      }
    },
    iconAction: function(k) {
      if (debugOut) {
        console.log(
            `pulldown select '${k}' \n action '${this.mojiSize[k].value}' `
        )
      }
      if (this.nowMojisize !== k) {
        this.nowMojisize = k
        this.letterSize = 18 + Math.floor(this.mojiSize[k].value * 1.5)
        this.graphRatio = this.mojiSize[k].gRatio
        this.$nextTick(() => {
          this.layoutCalc()
          this.$refs.bookpage.handleResize()
        })
      }
    },
    pulldownCancel: function() {
      if (debugOut) {console.log("pulldown cancel!");}
    },
    makeBookmarkURL: function(idx) {
      var newQuery = {}
      if (!isNaN(this.authorId)) newQuery["author"] = this.authorId
      if (!isNaN(this.contentsId)) newQuery["record"] = this.contentsId
      if (idx != undefined) this.displayIndex = idx
      if (!isNaN(this.displayIndex)) newQuery["index"] = this.displayIndex
      this.$router.replace({ query: newQuery }, () => {}, () => {})
    },
    pvAdvance: function(ofs) {
      if (debugOut) {console.log(`pvAdvance ${ofs}`)}
    },
    pageviewClick: function(e) {
      if (this.slvis) {
        this.slvis = false
        return
      }

      if (this.uivis) {
        this.uivis = false
      } else {
        if (this.uiToggleBorder > e.offsetY) {
          this.uivis = true
        } else {
          if (this.goLeftBorder > e.offsetX) {
            // this.browsevis = false
            this.goLeft()
            return
          }
          if (this.goRightBorder < e.offsetX) {
            // this.browsevis = false
            this.goRight()
            return
          }
          this.browsevis = !this.browsevis
        }
      }
      // let nav = document.getElementById('nav');
      // nav.style.display = this.uivis ? 'block' : 'none';
      this.$root.setNavHide(!this.uivis)
      this.slvis = false
    },
    storeInfo: function () {
      if (this.authorId < 1000 || this.contentsId < 1000) { return }
      if (!this.saveContents) { this.saveContents = {} }
      this.saveContents['lastContents'] = {'author':this.authorId,'contents':this.contentsId,'newIndex':this.newIndex}
      let aID = this.authorId.toString()
      if (!this.saveContents[aID]) { this.saveContents[aID] = {} }
      this.saveContents[aID]['contents'] = this.contentsId
      this.saveContents[aID]['newIndex'] = this.newIndex
    },
    handleResize() {
      clearTimeout(timer)
      this.notResigingDoc = false
      timer = setTimeout(() => {
        if (debugOut) {console.log('window resize!')}
        this.docAreaResize()
        this.layoutCalc()
        this.$refs.bookpage.handleResize()
        this.notResigingDoc = true
      }, 1000)
    },
    pageNumberToSliderValue: function(number) {
      this.pageSliderValue = this.layoutParams.pageFeedRight ? (this.layoutParams.numOfPages - number) : number
    },
    docAreaResize() {
      this.updateDocumentAreaWH()
      // this.viewWidth = this.documentAreaWidth
      // this.viewHeight = this.documentAreaHeight
    },
    authResult(result) {
      this.nowEmail = null
      if (result) {

      }
      this.authDisp = false
    },
    affiset: function() {
      let list = {}
      let maxImageWidth = 0
      let maxTextWidth = 0
      this.buyStores = null
      this.affiList.forEach((value,index) => {
        let keyName = null
        let tmpObj = { url:null, name:null, image:null, imageWidth:null }
        switch (value.site) {
          case 0:           //Amazon
            keyName = 'Amazon-' + index
            tmpObj.url = this.$root.$options.amaAffiUrl + `${value.pid}/${amsAsoID}`
            tmpObj.name = value.name
            tmpObj.image = "af_banner/ama_middle.png"
            tmpObj.imageWidth = 168
            break
          case 1:           //Kindle
            keyName = 'Amazon-' + index
            tmpObj.url = this.$root.$options.amaAffiUrl + `${value.pid}/${amsAsoID}`
            tmpObj.name = value.name
            tmpObj.image = "af_banner/ama_middle.png"
            tmpObj.imageWidth = 168
            break
          case 10:          //Rakuten Books
            keyName = 'Rakuten-' + index
            tmpObj.url = value.pid
            tmpObj.name = value.name
            tmpObj.image = "af_banner/rak_middle.png"
            tmpObj.imageWidth = 180
            break
          default:
            break
        }
        if (keyName) {
          if (maxImageWidth < tmpObj.imageWidth) { maxImageWidth = tmpObj.imageWidth }
          if (tmpObj.name) {
            let tmpWidth =  this.calcTextWidth(tmpObj.name)
            if (maxTextWidth < tmpWidth) { maxTextWidth = tmpWidth }
          }
          list[keyName] = tmpObj
        }
      })
      if (list !== {}) {
        this.storesInfo = { 'maxImageWidth':maxImageWidth, 'maxTextWidth':maxTextWidth }
        this.storesItemWidth = Math.ceil((maxImageWidth + maxTextWidth + 20) * 1.2)
        this.buyStores = list
      }
    },
    async svgToImage(svg) {
      return new Promise((resolve, reject) => {
        let blob = new Blob([Buffer.from(svg, 'utf-8')], {type: 'image/svg+xml'})   //参考例ではtypeは'image/svg+xml;charset=utf-8'だったが、SafariでBlobのtypeにcharsetがあると動かない様なので削除
        let url = URL.createObjectURL(blob);
        let image = document.createElement('img');
        image.onload = (e) => {
          resolve(image)
        }
        image.onerror = (e) => {
          if (debugOut) {console.log(`SVG to Imageを失敗した`)}
          reject(e)
        }
        image.src = url;
      })
    },
    layoutCalc: function() {
      if (debugOut) {console.log('layoutCalc')}
      this.paging = true
      let vertically = (this.composed.vertical === true)
      let letterSize = this.letterSize
      let letterGap = Math.floor(letterSize * (charSpacing - 1) * 10) / 10
      let lineHeight = Math.floor(letterSize * lineSpacing * 10) / 10
      let docWidth = this.documentAreaWidth
      let docHeight = this.documentAreaHeight
      let areaRatio = docWidth / docHeight
      // let landscape = (screenRatio > 1);
      if (vertically) {
        let wpages = (areaRatio < this.wpagesLimitV)
        if (wpages) docHeight /= 2      //縦長の比率が一定以下なら縦2段表示にする
        this.layoutParams.wpages = wpages
      } else {
        let wpages = (areaRatio > this.wpagesLimit)
        if (wpages) docWidth /= 2      //横長の比率が一定以上ならポートレート見開き表示にする
        this.layoutParams.wpages = wpages
      }
      let docRatio = docWidth / docHeight
      let contentsRatio = 1 - (this.contentsMargin * 2)
      let columnsWidth = Math.floor((vertically ? docHeight : docWidth) * contentsRatio)
      let linesWidth = Math.floor((vertically ? docWidth : docHeight) * contentsRatio)
      let numColumn = Math.floor(columnsWidth / (letterSize + letterGap));
      let wpContentsWidth = Math.floor((vertically ? docHeight : docWidth) * contentsRatio)
      this.topFiller = 0
      this.bottomFiller = 0
      if (debugOut) {console.log(`docRatio:${docRatio} / numColumn:${numColumn}`)}
      if (docRatio < this.fillerLimit) {
        docHeight = Math.ceil(docWidth / this.fillerLimit)
        this.topFiller = Math.floor((this.documentAreaHeight - docHeight) / 2)
        this.bottomFiller = this.documentAreaHeight - this.topFiller - docHeight
      }
      this.layoutParams.vertically = vertically
      this.layoutParams.pageFeedRight = this.composed.pageFeedRight !== undefined ? this.composed.pageFeedRight : this.layoutParams.vertically
      this.layoutParams.authorName = this.composed.author || '作者不詳'
      this.layoutParams.contentsTitle = this.composed.title || '名称未設定'
      this.layoutParams.pageStart = this.composed.startPage
      this.layoutParams.letterFont = this.letterFont
      this.layoutParams.letterVFont = this.letterVFont
      this.layoutParams.letterSize = letterSize
      // this.layoutParams.bottomCorrection = bottomCorrection
      this.layoutParams.graphRatio = this.graphRatio
      this.layoutParams.gapSize = letterGap
      this.layoutParams.docWidth = docWidth
      this.layoutParams.docHeight = docHeight
      this.layoutParams.linesWidth = linesWidth
      this.layoutParams.columnsWidth = columnsWidth
      this.layoutParams.contentsMargin = this.contentsMargin
      this.layoutParams.wpContentsWidth = wpContentsWidth
      this.layoutParams.appAreaAspect = areaRatio
      this.layoutParams.numColumn = numColumn
      this.layoutParams.logicalNumLine = Math.floor(linesWidth / lineHeight)
      this.layoutParams.numLine = this.layoutParams.logicalNumLine * (this.layoutParams.wpages ? 2 : 1)
      this.layoutParams.lineHeight = lineHeight
      this.goLeftBorder = Math.floor(this.documentAreaWidth * 0.4)      //左5分の2
      this.goRightBorder = Math.floor(this.documentAreaWidth * 0.6)     //右5分の2
      this.uiToggleBorder = Math.floor(this.documentAreaHeight / 3)     //上から3分の1

      this.layoutParams.offcvs = document.createElement("canvas")
      let canvas = this.layoutParams.offcvs
      if (debugOut) {console.log(`canvas wh:${this.documentAreaWidth * window.devicePixelRatio} x ${this.documentAreaHeight * window.devicePixelRatio} st:${this.documentAreaWidth} x ${this.documentAreaHeight}`)}
      canvas.width = this.documentAreaWidth * window.devicePixelRatio
      canvas.height = this.documentAreaHeight * window.devicePixelRatio
      canvas.style.width = this.documentAreaWidth + "px"
      canvas.style.height = this.documentAreaHeight + "px"
      let ctx = canvas.getContext("2d")
      ctx.scale(window.devicePixelRatio, window.devicePixelRatio)

      if (debugOut) {console.log(this.composed)}
      let layoutData = this.layout(this.composed,numColumn)
      if (debugOut) {console.log(layoutData)}
      let pdata = this.layoutToPagedata(layoutData,this.layoutParams)
      if (debugOut) {console.log(pdata)}
      this.layoutParams.numOfPages = pdata.length
      this.pageData = pdata

      this.$refs.bookpage.setLayoutParams(this.layoutParams,pdata,layoutData,this.gaijiList)

      this.paging = false
    },
    layout: function (linesData, column) {
      if (!(linesData)) return null
      if (column === undefined) column = 40
      let vert = linesData.vertical || false
      let toukinList = toukin_bura + toukin_wa_h + toukin_wa + toukin_hyphen + toukin_kugiri + toukin_nakaguro
      let buraCheckLen = toukin_bura.length
      let buraHCheckLen = buraCheckLen + toukin_wa_h.length
      let matsukinList = matsukin
      let offcvs = document.createElement("canvas")
      // let linesSpace = tentativeSize * (lineSpacing - 1)
      let tentaWidthLimit = charSpacing * tentativeSize * column//(charSpacing * tentativeSize * (column - 1)) + tentativeSize
      // let linesSpace = tentativeSize * (lineSpacing - 1)
      offcvs.width = 400
      offcvs.height = 40
      let ctx = offcvs.getContext("2d")
      ctx.font = tentaFontStyle

      let numLine = linesData.contents.length
      let resultLines = []
      let alpt = 0
      let lineNumber = 0
      let cvstart = performance.now()
      linesData.contents.forEach((paragraph,pIdx) => {
        // if (debugOut) {
        //   if (pIdx === 802) {
        //     console.log("")
        //   }
        // }
        if (!paragraph) {
          if (debugOut) { console.log("paragraph is null.") }
        }
        let indent = paragraph.indent || 0
        let nombreMode = paragraph.nombre || NombreMode.on
        let orders = paragraph.line || []
        let flags = paragraph.flags
        let newpageFlag = (flags & PropFlag.newpage) !== 0
        let subjectFlag = (flags & PropFlag.subject) !== 0
        let hasLineFlag = (flags & PropFlag.hasLine) !== 0
        let hasDotFlag = (flags & PropFlag.hasDot) !== 0
        let hasRubyFlag = (flags & PropFlag.hasRuby) !== 0
        let hasStrikeFlag = (flags & PropFlag.hasStrike) !== 0
        let feedFlag = (flags & PropFlag.feed) !== 0
        let displines = []
        let lpt = 0
        let ltrLength = orders.length

        let nowLine = LineStyle.end
        let nowStrike = LineStyle.end
        let nowDot = ""
        let rubys = []
        let lineEndIndexes = []
        let lineEndSpcIndexes = []     //行末で見かけの改行位置がずれる文字の段落内文字インデックス
        let nowSentence = -1
        if (debugOut) {
          if (hasRubyFlag) {
            console.log("hasRubyFlag")
          }
        }
        while (lpt < ltrLength) {
          let lineHeader = { start:0, length:0, n:lineNumber, ni:0, properties:0, letters:null, picture:null, pagenew:false, rubys:null, nm:nombreMode, fd:feedFlag }
          feedFlag = false  //trueの場合、段落最初の行にだけ記録するためにlineHeaderに記録したらfalseに初期化しておく
          let letters = []
          let start = lpt
          let tempTentativeSize = tentativeSize * (subjectFlag ? subjectRatio : 1)
          let charSpace = Math.ceil(tempTentativeSize * (charSpacing - 1) * 10) / 10
          let charSpaceBuffer = charSpace * 2
          let nowPoint = (indent + (subjectFlag ? 1 : 0)) * tentativeSize * charSpacing
          let tempLineWidth = tentaWidthLimit - nowPoint
          let miniPoint = nowPoint
          let nowProps = flags & PropFlag.subject
          let nowPicNum = null
          let nowPicCaption = null
          let skipLptAdjust = 0       //縦中横によって1文字分の高さに複数の文字が格納される場合の調整値。ルビ振りの処理に使う
          let rubySkip = 0            //ルビ対象の文字列の先頭がskipLptAdjustの調整対象だった場合に余計な調整になるので、それを回避する為に必要な変数
          let incLpt = 1
          let lastRubyIndex = -1

          let orderPush = (o,letter) => {
            if (hasLineFlag) {
              if (o.ls !== null) {
                nowLine = o.ls
                if (nowLine !== LineStyle.end) nowProps |= PropFlag.hasLine
              }
            }
            if (hasStrikeFlag) {
              if (o.ss !== null) {
                nowStrike = o.ss
                if (nowStrike !== LineStyle.end) nowProps |= PropFlag.hasStrike
              }
            }
            if (hasDotFlag) {
              if (o.ds !== null) {
                nowDot = o.ds
                if (nowDot !== "") nowProps |= PropFlag.hasDot
              }
            }
            if (o.pt) {
              nowProps |= PropFlag.hasPicture
              nowPicNum = o.pt.picNumber
              nowPicCaption = o.pt.picCaption
            }
            if (hasRubyFlag) {
              if (o.r !== null) {
                // if (o.l === '瞼') {
                //   console.log('まぶた')
                // }
                lastRubyIndex = rubys.length
                let newStart = lpt - start - rubySkip
                if (newStart < 0) {
                  if (debugOut) {console.log(`lpt:${lpt} / start:${start} / skipLptAdjust:${skipLptAdjust} / rubySkip:${rubySkip} / newStart:${newStart}`)}
                  // newStart = 1
                }
                rubys.push({
                  start: newStart,
                  length: o.r.length,
                  point: nowPoint,
                  ruby: o.r.ruby,
                  width:o.r.width,
                  area: 0,
                  type: o.r.rubyType,
                })
               }
              if (lastRubyIndex !== -1) {
                if ((o.t & WordTypeMask.tateHanMask) === WordType.tc_ur) {
                  rubys[lastRubyIndex].length -= o.tl - 1
                }
              }
            } else {
                lastRubyIndex = -1
            }
            let space = charSpace
            let width = o.w
            if (o.t & WordTypeMask.noGapMask) {
              if ((o.t & WordTypeMask.tateHanMask) !== WordType.tc_ur) {
                space = 0
              }
            }
            if (o.t & WordTypeMask.tagControlMask) {
              space = 0
              width = 0
            }
            let tmpLetter = {
              letter: letter,
              pictureTag: o.pt,
              type: o.t,
              dot: nowDot,
              line: nowLine,
              strike: nowStrike,
              width:width,
              charspace: space,
              point: 0,
            }
            letters.push(tmpLetter)
            return tmpLetter
          }

          let tmpLimit = tentaWidthLimit
          lastRubyIndex = -1
          skipLptAdjust = 0
          rubySkip = 0
          do {
            let order = Object.assign({},orders[lpt])
            if (subjectFlag) {
              order.w *= subjectRatio
            }
            // if (debugOut) {console.log(`${order.l} ${((order.t & WordTypeMask.tateHanMask) === WordType.tc_ur) ? '[tc_ur]' : ''}`)}
            // if (debugOut) {
            //   if (order.l === '巡') {
            //     console.log('debug:巡発見!')
            //   }
            // }
            incLpt = 1
            let pushLetter = order.l
            let nextPoint = nowPoint + order.w
            // let nextMiniPoint = miniPoint + ((order.t & WordTypeMask.hantsumeMask) !== 0 ? order.w * hantWidthRatio : order.w)
            if (nowSentence >= 0) { //センテンス処理中
              if (((order.t & WordTypeMask.wordSaveMask) === 0) || ((order.tw) && (nowSentence !== lpt))) {
                nowSentence = -1
              } else {
                if ((order.l === ' ') && (order.t !== WordType.kaomoji)){
                  if (nextPoint >= tmpLimit) {    //行末に半角スペースが入る様ならスキップ
                    break
                  }
                }
              }
            } else {              //現在センテンス未処理
              if ((order.t & WordTypeMask.tateHanMask) === WordType.tc_ur) {
                // if (debugOut) {console.log(`unsentence - tc_ur:${order.tw} (pushed:${pushLetter})`)}
                if (order.tw) {
                  pushLetter = order.tw
                  incLpt = order.tl
                  skipLptAdjust += order.tl - 1
                }
              } else {
                if ((order.t & WordTypeMask.wordSaveMask) !== 0) { //センテンス処理対象
                  if (order.tw) {                               //センテンス対象文字列が格納されている→対象ブロック先頭
                    nowSentence = lpt
                    let twWidth = ctx.measureText(order.tw).width / fontMeasureRatio
                    if (nowPoint + twWidth > tentaWidthLimit) { //typeWord全体を出力するとはみ出してしまう場合
                      if (order.t2) {               //スペースで単語に分割可能の場合
                        let spWidth = ctx.measureText(' ').width / fontMeasureRatio
                        let tempWidth = 0
                        order.t2.some((w, wIdx) => {
                          if (nowPoint + tempWidth + w + (spWidth * wIdx) > tentaWidthLimit) {  //単語ごとにチェック
                            tmpLimit = nowPoint + tempWidth + (spWidth * wIdx)
                            return true
                          } else {
                            nowSentence = -1
                            tempWidth += w
                          }
                        })
                      } else {            //単語に分割できない場合
                        if (lpt === start) {  // 行先頭から出力。つまりそもそも一行分の幅で出力できない場合
                          //諦めてそのまま出力
                        } else {
                          // lpt += 1       --- ここでの処理は現在の文字ポインター位置以降を次行に送るものなので、lptを進めてはダメ
                          break // 改行
                        }
                      }
                    }
                  }
                }
              }
            }
            if (nextPoint >= tmpLimit) {  //末尾禁則チェック
              // if (nowSentence >= 0) {
              //   // lpt += 1
              //   break
              // }
              // let check = matsukinList.indexOf(pushLetter)
              // if (check !== -1) break
              if (nowSentence < 0) {
                let check = matsukinList.indexOf(pushLetter)
                if (check !== -1) break
              }
            }

            let tmpLetter = orderPush(order,pushLetter)
            nowPoint = nextPoint + tmpLetter.charspace
            miniPoint += (tmpLetter.type & WordTypeMask.hantsumeMask) !== 0 ? tmpLetter.width * hantWidthRatio : tmpLetter.width
            lpt += incLpt
            rubySkip += skipLptAdjust
            skipLptAdjust = 0
          } while ((nowPoint < tmpLimit) && (lpt < ltrLength))
          let layoutLimit = tentaWidthLimit
          let bura = false
          if (nowPoint >= tentaWidthLimit) {   //次行の行頭禁則チェック。末尾禁則チェックおよびsentence処理でループを抜けた場合はこの処理は行わない
            let checkOffset = 0
            let kin = []
            while ((lpt + checkOffset) < ltrLength) {
              // if (debugOut) {
              //   console.log(`lpt:${lpt} checkOffset:${checkOffset} ltrLength:${ltrLength}`)
              //   if (lpt === 62) {
              //     console.log(`62--lineEndIndexes:${lineEndIndexes}\nlineEndSpcIndexes:${lineEndSpcIndexes}`)
              //   }
              // }
              let nextOrder = orders[lpt + checkOffset]
              if (nextOrder.tw) {
                if ((nextOrder.t & WordTypeMask.tateHanMask) === WordType.tc_ur) {
                  let tmpTcur = []
                  let check = -1
                  if (Array.from(nextOrder.tw).some(((value) => {
                    check = toukinList.indexOf(value)
                    tmpTcur.push(check)
                    return (check === -1)
                  }))) {
                    break
                  } else {
                    if (debugOut) {console.log(`行頭禁則発見:'${nextOrder.tw}' [tc_ur]`)}
                    Array.prototype.push.apply(kin, tmpTcur)
                    checkOffset += tmpTcur.length
                  }
                } else {
                  checkOffset += (!nextOrder.tl) ? 1 : nextOrder.tl
                }
              } else {
                let check = toukinList.indexOf(nextOrder.l)
                if (check === -1) {
                  break
                }
                kin.push(check)
                checkOffset += 1
              }
            }
            if (checkOffset > 0) {
              if (kin[checkOffset - 1] < buraCheckLen) {
                layoutLimit = tentaWidthLimit + tempTentativeSize
                bura = true
              }

              for (let i = 0; (i < checkOffset) && (lpt < ltrLength); i++) {
                incLpt = 1
                let o = orders[lpt]
                let owidth = o.w
                let oletter = o.l
                if ((o.t & WordTypeMask.tateHanMask) === WordType.tc_ur) {
                  if (o.tw) {
                    if (debugOut) {console.log(`縦中横文字の行頭禁則処理:'${o.tw}' [tc_ur]`)}
                    oletter = o.tw
                    incLpt = o.tl
                    skipLptAdjust += o.tl - 1
                  }
                }
                let nextMiniPoint = miniPoint + ((o.t & WordTypeMask.hantsumeMask) !== 0 ? owidth * hantWidthRatio : owidth)
                if (nextMiniPoint > layoutLimit) break
                orderPush(o,oletter)
                nowPoint += owidth + charSpace
                miniPoint = nextMiniPoint
                lpt += incLpt
                rubySkip += skipLptAdjust
                skipLptAdjust = 0
              }
            }
          }
          if (nowPoint !== layoutLimit) {
            let delta = nowPoint - layoutLimit
            let gapableIndex = []
            let hantsumeIndex = []
            letters.forEach((value, index) => {
              // if ((value.type & WordTypeMask.noGapMask) === 0) {
              //   gapableIndex.push(index)
              // }
              if (value.charspace === charSpace) {
                gapableIndex.push(index)
              }
              if (delta > 0) {
                if ((value.type & WordTypeMask.hantsumeMask) !== 0) {
                  hantsumeIndex.push(index)
                }
              }
            })
            if (delta > 0) {  // 表示幅をはみ出してしまう場合（※miniPointでチェックしているので詰めれば収まるはず）
              let hantsumeWidth = tempTentativeSize * hantWidthRatio
              let hantsumeDelta = (tempTentativeSize - hantsumeWidth) * hantsumeIndex.length
              if (delta < hantsumeDelta) {
                hantsumeDelta = delta
                hantsumeWidth = tempTentativeSize - (delta / hantsumeIndex.length)
                delta = 0
              } else {
                delta -= hantsumeDelta
              }
              if (gapableIndex.length > 0) {
                let sub = delta / gapableIndex.length
                if (sub > charSpace) sub = charSpace
                gapableIndex.forEach(idxV => {
                  letters[idxV].charspace -= sub
                })
                delta -= sub * gapableIndex.length
              }
              if (delta > 0) {
                if (hantsumeIndex.length > 0) {
                  hantsumeIndex.forEach(idxV => {
                    letters[idxV].width = hantsumeWidth
                  })
                  delta -= hantsumeDelta * hantsumeIndex.length
                }
                if (delta > 0) {
                  //miniPointでチェックしているのでここは実行されないはず
                }
              }
            } else {          // 表示幅に余裕がある場合
              delta = -delta
              if ((lpt < ltrLength) && (delta > tempTentativeSize)) {  // まだ論理行が継続していて、余裕が1文字以上ある場合に調整
                if (gapableIndex.length === 0) {

                } else {
                  let add = delta / gapableIndex.length
                  if (add > charSpaceBuffer) add = charSpaceBuffer
                  gapableIndex.forEach(idxV => {
                    letters[idxV].charspace += add
                  })
                }
              }
            }
          }

          let point = (indent + (subjectFlag ? 1 : 0)) * tentativeSize * charSpacing
          letters.forEach((value, index, array) => {
            array[index].point = point
            point += value.width + value.charspace
          })
          if (letters.length > 0) {
            let endIndex = letters.length - 1
            lineEndIndexes.push(endIndex + alpt)
            while (/\s/.test(letters[endIndex].letter)) {   //行末尾のスペースを検出
              lineEndSpcIndexes.push(endIndex)
              endIndex -= 1
              if (endIndex < 0) { break }
            }
            if (endIndex >= 0) {                            //スペースを取り除いた後にまだ文字が残っていたら⋯
              if ((letters[endIndex].type & WordTypeMask.hantsumeMask) !== 0) { //行末尾が後半空白の記号かどうか検査
                lineEndSpcIndexes.push(endIndex)
              }
            }
            if (lineEndSpcIndexes.length) {
              lineEndSpcIndexes.sort((a,b) => { return a - b })
            }
          }

          let nowRubys = null
          if (rubys.length > 0) {
            let removeCount = 0
            let ept = lpt - start
            rubys.some((r,i,arr) => {
              if (r.start >= ept) return true
              if (r.start + r.length > ept) arr[i].type |= WordType.ruby_continue

              removeCount += 1
            })
            nowRubys = rubys.splice(0,removeCount)
          }


          if (nowSentence >= 0) {

          }
          lineHeader.start = alpt
          lineHeader.length = lpt - start
          lineHeader.n = lineNumber
          lineHeader.ni = 0
          lineHeader.properties = nowProps
          lineHeader.letters = Object.assign([],letters)
          lineHeader.picture = (nowPicNum === null) ? null : { picNum:nowPicNum, picCaption:nowPicCaption }
          lineHeader.pagenew = false
          lineHeader.rubys = Object.assign([],nowRubys)
          lineNumber += 1

          alpt += lineHeader.length
          displines.push(lineHeader)
        }

        if (debugOut) {console.log(`ルビlineEndIndexes:${lineEndIndexes}\nlineEndSpcIndexes:${lineEndSpcIndexes}`)}
        // if (debugOut) {
        //   if ((lineEndIndexes >= 118417) && (lineEndSpcIndexes === 23)) {
        //     console.log("")
        //   }
        // }
        // ctx.save()
        // ctx.font = rubyFontStyle
        let widthString = (w,s,t,r,i) => {
          let arr = Array.from(s)
          let poss = []
          if (!i) i = 0
          if (!t) t = 0
          let ww = 0
          // let lastDelm = -1
          let mod = 0
          let index = arr.findIndex((value, index) => {
            // if ((value === ' ') && ((t & WordTypeMask.sentenceStructMask) !== 0))  lastDelm = index
            let wm = Math.floor(ctx.measureText(value).width / fontMeasureRatio * 10) / 10
            if (r) wm *= r
            if ((ww + wm) > w) {
              mod = (ww + wm) - w
              return true
            }  else {
              poss.push(ww)
              ww += wm + i
              return false
            }
          })
          if (index !== -1) {
            // if (lastDelm !== -1) index = lastDelm
            return [arr.slice(0,index).join(''),mod,poss]
          } else {
            return [s,0,poss]
          }
        }
         let nextRuby = null
        let displineWidths = []
        displines.forEach((v, i, arr) => {
          let nowSubjectRatio = subjectFlag ? subjectRatio : 1
          let tempTentativeSize = tentativeSize * nowSubjectRatio
          let charSpace = Math.ceil(tempTentativeSize * (charSpacing - 1) * 10) / 10
          let charSpaceBuffer = charSpace * 2
          let lastSrp = arr[0].point
          let lastRed = tempTentativeSize
          let getWidths = (str,r,sbj,vert) => {
            let tw = Array.from(str)
            if (r === undefined) r = 1
            if (sbj === undefined) sbj = 1
            if (vert) {
              return tw.map(rl => {
                return tempTentativeSize * r * sbj
              })
            } else {
              return tw.map(rl => {
                return ctx.measureText(rl).width / fontMeasureRatio * r * sbj
              })
            }
          }
          if (nextRuby) {
            nextRuby.point = v.letters[0].point
            arr[i].rubys.unshift(nextRuby)
            nextRuby = null
          }
          arr[i].rubys.forEach((r, ri, rarr) => {
            if (r.width && subjectFlag) {
              rarr[ri].width *= nowSubjectRatio
            }
            // if (r.ruby === "ブラムビ") {
            //   console.log(JSON.stringify(r))
            // }
            let forRubyWidth = (st,length,ratio) => {
              if (!ratio) {ratio = 1}
              if (ratio !== 1) {
                if (debugOut) {console.log(ratio)}
                ratio = 1
              }
              let w = 0
              let lw = 0
              let count = 0
              let tv = v
              let ti = i
              let lastCs = 0
              let ltSt = tv.start + st
              let lineWidths = []
              // let handledStr = ""
              while (count < length) {
                let l = tv.letters[st + count]
                let lf = (l === undefined)
                if (lf) {
                  st = -count
                  ti += 1
                  tv = arr[ti]
                  if (tv === undefined) {
                    lineWidths.push((lw - lastCs) * ratio)
                    break
                  }
                  l = tv.letters[0]
                }
                if (l === undefined) {
                  lineWidths.push((lw - lastCs) * ratio)
                  break
                }
                // if (debugOut) {console.log(l.letter)}
                lastCs = lf ? 0 : l.charspace
                let nowWidth = l.width
                let nowLetter = l.letter
                if (lineEndSpcIndexes.includes(ltSt + count)) {
                  if ((l.type & WordTypeMask.hantsumeMask)!==0) {
                    nowWidth = l.width * hantWidthRatio
                  } else {
                    if (/\s/.test(nowLetter)) {
                      nowWidth = 0
                      lastCs = 0
                    }
                  }
                }
                // handledStr += nowLetter
                w += nowWidth + lastCs
                lw += nowWidth + lastCs
                // if (debugOut) {console.log(`lineEndIndexes check:${ltSt + count}`)}
                if (lineEndIndexes.includes(ltSt + count)) {
                  lw -= lastCs
                  lineWidths.push(lw * ratio)
                  lw = 0
                }
                count += 1
                if (count >= length) {
                  lineWidths.push((lw - lastCs) * ratio)
                  break
                }
              }
              // if (debugOut) {console.log(`Handled String:${handledStr}`)}
              let linesSum = lineWidths.reduce((previousValue, currentValue) => {
                return previousValue + currentValue
              })
              return [(w - lastCs) * ratio,lineWidths,linesSum]
            }
            let eli = r.start + r.length - 1    //ルビ振り対象文字列の最後の文字のインデックス
            let endLineIdx = v.letters.length - 1
            if (eli >= v.letters.length) {eli = endLineIdx}     //↑が表示行末を超えていたら行末の文字のインデックスに置換
            let saveEli = eli
            while (/\s/.test(v.letters[eli].letter)) {  //表示行中のルビ振り対象文字列の末尾スペースを対象外にする
              eli -= 1
              if (eli < 0) {
                eli = saveEli
                break
              }
            }
            if (saveEli === endLineIdx) {   //saveEliとendLineIdxが同じなら、eliは表示行末を指しているので、末尾スペース除外は流用できる
              endLineIdx = eli
            } else {
              // 異なるなら独自に除外
              while (/\s/.test(v.letters[endLineIdx].letter)) {
                endLineIdx -= 1
                if (endLineIdx < 0) {
                  endLineIdx = 0
                  break
                }
              }
            }
            let el = v.letters[endLineIdx]
            let elnp = el.point + (el.width * ((el.type & WordTypeMask.hantsumeMask) === 0 ? 1 : hantWidthRatio))
            el = v.letters[eli]
            // if (debugOut) {
            //   try {
            //     if (!('point' in v.letters[r.start])) {
            //       console.log(`not in point prop. r.start:${r.start} -- v.letters:${v.letters[r.start]}` )
            //     }
            //   } catch (e) {
            //    console.log(`primitive:\nr:${JSON.stringify(r)}\nv.letters[r.start]:${v.letters[r.start]}`)
            //   }
            // }
            let slp = v.letters[r.start].point
            let elp = el.point + el.width

            if ((r.type & WordType.kaomoji) !== 0) {  //顔文字
              let lw = elp - slp
              if (r.width <= lw) {  //ルビ振り対象文字列の範囲にルビが収まるならセンタリング
                rarr[ri].point = slp + (lw - r.width) * 0.5
              } else {
                let [wrw,lineWidths] = forRubyWidth(r.start, r.length, nowSubjectRatio)  //ルビ振り対象文字列の表示可能幅
                // let nnl = saveEli - r.start + 1                           //ルビ振り対象文字列の当行の文字数
                let nnw = elnp - slp                                         //ルビ振り対象の当行の表示可能範囲
                let nrw = 0
                if ((r.type & WordTypeMask.ruby_continueMask) !== 0) {//ルビ振り対象文字列が途中で改行する場合
                  nrw = wrw - nnw                                          //ルビ振り対象の次行以降の表示可能範囲
                  if (nrw > tempLineWidth) { nrw = tempLineWidth }             //次行以降の表示可能範囲が1行の描画範囲を超えているなら調整
                }
                if (nnw > nrw) {                                             //当行の方が幅が広いので当行に描画
                  let nrbysp = (rarr.length > ri + 1) ? v.letters[rarr[ri + 1].start].point : 0
                  let expandable = false
                  // if ((r.length === 1) && (r.width <= (tempTentativeSize * 2))) { //漢字1字分左右に広げてみる
                  //   let tslp = slp - tempTentativeSize
                  //   let telp = elp + tempTentativeSize
                  //   if (tslp < lastRed) { tslp = lastRed }
                  //   if ((nrbysp !== 0) && (telp > nrbysp)) { telp = nrbysp }
                  //   if (r.width <= (telp - tslp)) {
                  //     rarr[ri].point = tslp + ((telp - tslp) - r.width) * 0.5
                  //     expandable = true
                  //   }
                  // }
                  if (!expandable) {      //まだ描画できていない
                    let tmpCenter = slp + (lw * 0.5)
                    let tmpLastRed = (lastRed === tempTentativeSize) ? -tempTentativeSize : lastRed    //lastRedが初期状態なら調整
                    let tmpEnd = tentaWidthLimit + tempTentativeSize
                    let tmpWidth = tmpEnd - tmpLastRed
                    let tmpHalfWidth = Math.min([tmpCenter - tmpLastRed, tmpEnd - tmpCenter])
                    if (tmpWidth >= r.width) {
                      if (tmpHalfWidth * 2 >= r.width) {
                        rarr[ri].point = tmpCenter - (r.width * 0.5)
                      } else {
                        rarr[ri].point = ((tmpCenter - tmpLastRed) < (tmpEnd - tmpCenter)) ? tmpLastRed : (tmpEnd - r.width)
                      }
                      expandable = true
                    }
                    if (!expandable) {
                      rarr[ri].point = tmpCenter - (r.width * 0.5)
                      rarr[ri].maxTextWidth = tmpHalfWidth * 2
                    }
                  }
                } else {  //次行があって、そちらの方が広い範囲を使える様なので送る
                  nextRuby = Object.assign({}, r)
                  nextRuby.start = 0
                  nextRuby.point = 0
                  nextRuby.type &= ~WordTypeMask.ruby_continueMask
                  rarr[ri].ruby = ""
                  rarr[ri].length = 0
                }
              }
            } else {    //顔文字以外
              let rlen = Array.from(r.ruby).length
              let interval = 0
              if (r.next) {
                if (debugOut) {console.log(JSON.stringify(r))}
                slp += r.next.interval * 0.5 //r.next.mod
                interval = r.next.interval
              }
              let lw = elp - slp
              // 基本的に均等割
              if (((r.type & WordTypeMask.ruby_continueMask) === 0) || (rlen <= 1)) {// ルビ振り対象文字列が当行で完結している場合
                if (r.width <= lw) {    //ルビ振り対象文字列の範囲にルビが収まるなら⋯
                  rarr[ri].widths = getWidths(r.ruby, rubyRatio, nowSubjectRatio,vert)
                  rarr[ri].point = slp
                  rarr[ri].area = lw
                } else {                //収まらない場合、適当な位置にセンタリング
                  let tmpCenter = slp + (lw * 0.5)
                  let tmpLastRed = (lastRed === tempTentativeSize) ? -tempTentativeSize : lastRed    //lastRedが初期状態なら調整
                  let tmpEnd = tentaWidthLimit + tempTentativeSize
                  let tmpWidth = tmpEnd - tmpLastRed
                  if (tmpWidth >= r.width) {
                    let tmpHalfWidth = Math.min(tmpCenter - tmpLastRed, tmpEnd - tmpCenter)
                    if (tmpHalfWidth * 2 >= r.width) {
                      rarr[ri].point = tmpCenter - (r.width * 0.5)
                    } else {
                      rarr[ri].point = ((tmpCenter - tmpLastRed) < (tmpEnd - tmpCenter)) ? tmpLastRed : (tmpEnd - r.width)
                    }
                  }
                }
              } else {                                              // ルビ振り対象文字列が途中で改行する場合、全域にわたった均等割にする
                let nnw = elnp - slp                                          //ルビ振り対象の当行の表示可能範囲
                if (displineWidths.length) {
                  nnw = displineWidths.shift()
                } else {
                  let widths = getWidths(r.ruby, rubyRatio, nowSubjectRatio,vert)
                  let rwidth = widths.reduce((previousValue, currentValue) => {
                    return previousValue + currentValue
                  })
                  let linesSum = 0
                  let wrw
                  // let wrw = forRubyWidth(r.start, r.length) * nowSubjectRatio  //ルビ振り対象文字列の表示可能範囲
                  [wrw,displineWidths,linesSum] = forRubyWidth(r.start, r.length, nowSubjectRatio)  //ルビ振り対象文字列の表示可能範囲
                  if (debugOut) {console.log(`ルビ幅${wrw} / ${linesSum} \n${JSON.stringify(displineWidths)}`)}
                  if (debugOut) {console.log(`ルビの総幅 ${r.width} ... ${rwidth}`)}
                  if (displineWidths.length) {nnw = displineWidths.shift()}
                  if (wrw < r.width) {
                    // TODO: 複数行のルビ振り処理で、ルビの全幅がルビ振り対象文字列の全幅を超えている場合の処理
                    if (debugOut) {console.log(wrw)}
                  }
                  if (!interval) {
                    interval = Math.floor((linesSum - rwidth) / (rlen) * 10) / 10   //隙間一つ当たりの幅
                    // slp += interval * 0.5
                  }
                }
                let [newRuby, mod, poss] = widthString(nnw, r.ruby, r.type, rubyRatio * nowSubjectRatio, interval)
                let nnl = saveEli + 1 - r.start                              //ルビ振り対象文字列の当行の文字数
                // let nnlRatio = nnw / wrw
                // let crw = r.width * nnlRatio
                // if (crw > nnw) crw = nnw
                // newRuby = widthString(crw, r.ruby, r.type, rubyRatio,interval)
                // }
                let newWidth = ctx.measureText(newRuby).width / fontMeasureRatio * rubyRatio * nowSubjectRatio
                let nRuby = r.ruby.substring(newRuby.length)
                let newLen = r.length - nnl
                if (newLen && (nRuby !== "")) {
                  nextRuby = Object.assign({}, r)
                  nextRuby.start = 0
                  nextRuby.length = newLen
                  nextRuby.point = 0
                  nextRuby.ruby = nRuby
                  nextRuby.width = ctx.measureText(nRuby).width / fontMeasureRatio * rubyRatio
                  nextRuby.type &= ~WordTypeMask.ruby_continueMask
                  nextRuby.next = {mod: mod, interval: interval}
                } else {
                  displineWidths = []
                }
                rarr[ri].length = nnl
                rarr[ri].ruby = newRuby
                rarr[ri].point = slp
                let npn = newWidth / nnw
                rarr[ri].poss = poss// getWidths(r.ruby, rubyRatio, nowSubjectRatio,vert)
                rarr[ri].area = nnw
                rarr[ri].width = newWidth
                rarr[ri].type = (nextRuby) ? (rarr[ri].type | WordType.ruby_continue) : (rarr[ri].type & ~WordTypeMask.ruby_continueMask)
              }
            }

            /*
            if (r.width <= lw) {         //ルビ振り対象文字列の範囲にルビが収まるなら、均等割で表示（顔文字の場合はセンタリング）
              // if ((r.type & WordTypeMask.noGapMask) !== 0) {  //顔文字、半角英字、半角カナ
              if ((r.type & WordType.kaomoji) !== 0) {  //顔文字
                rarr[ri].point = slp + (lw - r.width) * 0.5
              } else {                                        //均等割指定
                rarr[ri].widths = getWidths(r.ruby,rubyRatio,nowSubjectRatio,vert)
                rarr[ri].point = slp
                rarr[ri].area = lw
              }
            } else {
              let nrbysp = (rarr.length > ri + 1) ? v.letters[rarr[ri + 1].start].point : 0
              let expandable = false
              if ((r.length === 1) && (r.width <= (tempTentativeSize * 2))) {
                let tslp = slp - (tempTentativeSize * 0.5)
                let telp = elp + (tempTentativeSize * 0.5)
                if (tslp < lastRed) { tslp = lastRed }
                if ((nrbysp !== 0) && (telp > nrbysp)) { telp = nrbysp }
                if (r.width <= (telp - tslp)) {
                  rarr[ri].point = tslp + ((telp - tslp) - r.width) * 0.5
                  expandable = true
                }
              }
              if (!expandable) {
                let elm = elnp                           //ルビ表示可能範囲を行末に設定
                if (debugOut) {
                  console.log(`elm: ${elm}`)
                }
                if (nrbysp !== 0) elm = nrbysp           //同行に次のルビがある場合はその先頭に変更
                if (slp + r.width <= elm) {                                           //表示可能範囲に収まる場合、肩付き表示
                  rarr[ri].point = slp
                } else {                                                              //表示可能範囲に収まらない場合
                  if ((r.type & WordTypeMask.ruby_continueMask) !== 0) {              //ルビ振り対象文字列が途中で改行する場合

                    let wrw = forRubyWidth(r.start, r.length) * nowSubjectRatio  //ルビ振り対象文字列の表示可能範囲
                    let nnl = saveEli - r.start + 1     //ルビ振り対象文字列の当行の文字数
                    let nnw = elm - slp             //ルビ振り対象の当行の表示可能範囲
                    let newRuby
                    // if (r.width >= wrw) {
                    //   newRuby = widthString(nnw, r.ruby, r.type, rubyRatio)
                    // } else {
                    // let nnlRatio = nnl / r.length
                    let interval = (wrw - r.width) / Array.from(r.ruby).length
                    newRuby = widthString(nnw, r.ruby, r.type, rubyRatio,interval)
                    // let nnlRatio = nnw / wrw
                    // let crw = r.width * nnlRatio
                    // if (crw > nnw) crw = nnw
                    // newRuby = widthString(crw, r.ruby, r.type, rubyRatio,interval)
                    // }
                    let nRuby = r.ruby.substring(newRuby.length)
                    let newWidth = ctx.measureText(newRuby).width / fontMeasureRatio * rubyRatio * nowSubjectRatio
                    nextRuby = Object.assign({}, r)
                    nextRuby.start = 0
                    nextRuby.length = r.length - nnl
                    nextRuby.point = 0
                    nextRuby.ruby = nRuby
                    nextRuby.width = ctx.measureText(nRuby).width / fontMeasureRatio * rubyRatio * nowSubjectRatio
                    nextRuby.type ^= WordType.ruby_continue
                    rarr[ri].length = nnl
                    rarr[ri].ruby = newRuby
                    let npn = newWidth / nnw
                    if ((npn < 0.7) && ((r.type & WordTypeMask.noGapMask) === 0)) {   //余白がある程度できる様なら均等割
                    //if (npn < 0.7) {   //余白がある程度できる様なら均等割
                      if (debugOut) {
                        console.log(`font npn ${npn} = ${newWidth} / ${nnw} [${newRuby}]`)
                      }
                      rarr[ri].widths = getWidths(r.ruby, rubyRatio, nowSubjectRatio,vert)
                      rarr[ri].area = nnw
                    } else {
                      if (npn > 1) {
                        rarr[ri].point = elm - newWidth         //末尾寄せ
                      } else {
                        rarr[ri].point = slp + (nnw - newWidth) / 2  //センタリング
                      }
                    }
                    rarr[ri].width = newWidth
                    rarr[ri].type ^= WordType.ruby_continue
                  } else {                                                //ルビ振り対象文字列が当行に収まる場合
                    if (lastSrp + r.width <= elm) {                       //ルビ表示範囲を前方に広げて収まる場合
                      rarr[ri].point = ((elm - lastSrp) * 0.5 + lastSrp) - r.width * 0.5   //範囲の中央に表示
                    } else {
                      let tw = tentaWidthLimit - charSpace - lastSrp + rubySize + rubySize
                      if ((rarr.length === ri + 1) && (tw <= r.width)) {  //当行最後のルビで、ルビ2文字分のはみ出しで収まる場合
                        rarr[ri].point = lastSrp + (tw - r.width) * 0.5   //新しい範囲でセンタリング
                      } else {
                        if (lastSrp + (r.width * 0.9) <= elm) {           //前方に広げたルビ表示範囲でルビ文字を1割狭めて表示できる場合
                          rarr[ri].point = elm - (r.width * 0.9)
                          rarr[ri].type |= WordType.ruby_slim
                        } else {                                          //表示できそうに無いので非表示に
                          rarr[ri].type |= WordType.ruby_off
                          rarr[ri].point = slp
                        }
                      }
                    }
                  }
                }
              }
            }
            */
            lastSrp = rarr[ri].point + rarr[ri].width
            lastRed = lastSrp
          })
          arr[i].rubys.filter((value => {
            return value.length !== 0
          }))
          if (v.properties & PropFlag.hasPicture) {


          }
        })
        // ctx.restore()
        if (newpageFlag) {
          displines[displines.length - 1].pagenew = true
        }

        Array.prototype.push.apply(resultLines,displines)
      })




      let cvtime = performance.now() - cvstart
      if (debugOut) {console.log(`Page-text composing: clmn:${column} vertical:${vert} gen. time:${cvtime} ms`)}
      return {
        contents:resultLines,
        pictures:linesData.pictures,
        error:null
      }
    },
    layoutToPagedata(layoutData,layoutParams) {
      let numLine = layoutParams.numLine
      let linesLimit = layoutParams.linesWidth
      let linesCenter = (Math.round(layoutParams.logicalNumLine / 2) * layoutParams.lineHeight)
      let cvstart = performance.now()
      //
      let pageStartIndex = 0
      let pages = []
      let lineIndex = []
      let nextPicture = null
      let checkHeight = 0
      let wpageColumn = 0
      let pageLength = 0
      let wpageLineCount = null
      let coverPicNum = PictureFlags.coverPage | ((this.composed.coverPicFill === true) ? PictureFlags.fillPage : 0)
      let nombre = NombreMode.on
      let pagePush = (pic,len,wplen,nmv) => {
        if ((len === undefined) || (len === 0)) len = 1
        if (nmv === undefined) nmv = nombre
        pages.push({
          index: Object.assign([], lineIndex),
          picture: pic !== null ? Object.assign({}, pic) : null ,
          start: pageStartIndex,
          length: len,
          wpLen: wplen || null,
          nombre: nmv,
        })
        lineIndex = []
        if (pic !== null) nextPicture = null
        pageStartIndex += len
        pageLength = 0
        checkHeight = 0
        wpageColumn = 0
        wpageLineCount = 0
      }
      let lastIndex = layoutData.contents.length - 1
      pagePush({picNum:coverPicNum, picCaption:null})                      //トップカバーページ作成
      layoutData.contents.forEach((v, i, array) => {
        if (pageLength === 0) {         //ページ最初
          if (nextPicture !== null) {   //前のページで画像読み込みの指示があった
            pagePush(nextPicture)
          }
          if ( (v.properties & PropFlag.hasPicture)
              && v.pagenew                                  //現在行に画像タグと改ページタグあり。かつ他の文字が無い
              && (v.letters.length <= 1)                    //上2タグのみ
          ) {
            nombre = v.nm
            // if (debugOut) {console.log(`Nombre: ${nombre} (paragraph:${i})`)}
            pagePush(v.picture)
            return
          }
        }
        let nv = (i >= lastIndex) ? null : array[i + 1]
        nombre = v.nm
        // if (debugOut) {console.log(`Nombre: ${nombre} (paragraph:${i})`)}
        if (v.fd) {
          let specialIndex = wpageColumn ? SpecialLineIndex.lineFeedWp : SpecialLineIndex.lineFeed

          let tmpCheckHeight = checkHeight + this.layoutParams.lineHeight
          while (tmpCheckHeight < linesCenter) {
            lineIndex.push(specialIndex)
            tmpCheckHeight += this.layoutParams.lineHeight
          }
          checkHeight = tmpCheckHeight
        }
        if (v.properties & PropFlag.hasPicture) nextPicture = v.picture
        lineIndex.push(i)
        pageLength += v.letters.length
        if (checkHeight === 0) { checkHeight = this.layoutParams.lineHeight * ((v.properties & PropFlag.subject) ? subjectRatio : 1) }
        let nextHeight = 0
        let nextCheckHeight = 0
        if (nv) {
          let sr = (nv.properties & PropFlag.subject) ? subjectRatio : 1
          nextHeight = this.layoutParams.lineHeight * sr
          nextCheckHeight = (this.layoutParams.lineHeight - this.layoutParams.letterSize) * sr
        }
        if (wpageColumn) { array[i].properties |= PropFlag.isWpage }

        let lastLine = v.pagenew || !nv
        checkHeight += nextHeight
        if (!lastLine && (linesLimit < (checkHeight - nextCheckHeight))) {
          if (layoutParams.wpages && (wpageColumn === 0)) {
            wpageColumn += 1
            checkHeight = 0
            wpageLineCount = lineIndex.length
          } else {
            lastLine = true
          }
        }
        if (lastLine) {
          pagePush(null,pageLength,wpageLineCount)
        }
      })
      if (nextPicture || pageLength) {
        pagePush(nextPicture,pageLength,wpageLineCount)
      }

      //
      let cvtime = performance.now() - cvstart
      if (debugOut) {console.log(`Pagenize: time:${cvtime} ms`)}
      //
      return pages
    },
  }
};
</script>

<style lang="scss" scoped>
.book {
    z-index: -300;
    pointer-events: none;
    /*-webkit-overflow-scrolling: touch;*/
}

.background {
    background: #666666;
    position: fixed;
    z-index: -10;
    pointer-events: none;
}

.ui-base {
    position: fixed;
    display:-webkit-flex;
    display:flex;
    justify-content: space-around;
}

.uifooter {
  position: fixed;
  bottom: 0;
  height: 48px;
  width: 98vw;
  display: block;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  padding: 0;
  margin: 0;
}
.sliderbox {
  position: fixed;
  bottom: 8px;
  height: 64px;
  width: 98vw;
  display: block;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  padding: 0;
  margin: 0;
  z-index: 1;
  justify-content: center;
}

.slidervalue {
  position: absolute;
  display: flex;
  width: 20%;
  left: 40%;            // (100% - width) / 2
  bottom: 0px;
  margin: 2px 0px;
  border: 3px double #ddd;
  padding: 2px;
  justify-content: center;
  background-color: rgba(255,255,255,0.75);
}
</style>
